import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CanvasTimeline from './../canvas-timeline/canvas_timeline';
import {FormattedMessage, injectIntl} from 'react-intl';
import PersonGroup from './groups/person_group';
import TimelineHeatmapPersonGroup from './groups/timeline_heatmap_person_group';
import UploadingOverlay from '../../../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import {
	BUTTON_COLOR,
	BUTTON_STYLE,
	ESTIMATION_UNIT,
	profilePicSrc,
	PROJECT_STATUS,
	projectGroupUrl,
	projectUrl,
	WorkflowCategories,
} from '../../../constants';
import {
	areItemDatesValid,
	AUTO_SCHEDULING_PERSON_WIDTH,
	createCanvasTimelineDate,
	CURSOR,
	DATE_STEPS_SECTION_HEIGHT,
	drawHexagon,
	drawRectangle,
	getCanvasTimelineDateFromMoment,
	getHolidayDates,
	getMinutesInWeekdays,
	getMomentFromCanvasTimelineDate,
	getWeekdaysBetweenDates,
	GROUP_SECTION_WIDTH,
	GROUP_TYPE,
	isDateWithinPersonStartEndDate,
	isSimulationMode,
	ITEM_DRAG_POINT,
	ITEM_TYPE,
	setSimulationMode,
	setTimestampCorrelationId,
	setTimestampDataLoaded,
	setTimestampLabel,
} from '../canvas-timeline/canvas_timeline_util';
import Util from '../../../forecast-app/shared/util/util';
import HeatmapItem from '../people-scheduling/items/heatmap_item';
import TimeOffItem from '../people-scheduling/items/timeoff_item';
import {getAllocationTotal} from '../../scheduling/project_allocation_logic';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import ActionMenu from '../action_menu';
import Warning from '../../../components/warning';
import DeleteProjectMutation from '../../../mutations/delete_project_mutation';
import {shiftDependencyChain, updateAllocation, updateProject, updateTask} from '../../scheduling/scheduling_mutations';
import MovePhaseOnTimelineMutation from '../../../mutations/move_phase_on_timeline_mutation.modern';
import MoveProjectOnTimelineMutation from '../../../mutations/move_project_on_timeline_mutation';
import DistributionBox from './canvas_projects_scheduling_distribution_box';
import Moment, * as moment from 'moment';
import {dispatch, EVENT_ID, subscribe, unsubscribe} from '../../../containers/event_manager';
import TaskAllocationItem from './items/task_allocation_item';
import ContextMenu from '../../../forecast-app/shared/components/context-menus/context_menu';
import TaskDetailBox from '../components/task_detail_box';
import AllocationDetailBox from '../components/allocation_detail_box';
import Person from '../../../forecast-app/shared/components/person/person';
import {cacheManager} from '../canvas-timeline/canvas_timeline_cache_manager';
import PersonUtilizationWebWorker from './person_utilization.worker.js';
import {interactionManager} from '../canvas-timeline/canvas_timeline_interaction_manager';
import AutoSchedulingDropdown from './autoscheduling/auto_scheduling_dropdown';
import CustomScrollDiv from '../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import * as tracking from '../../../tracking';
import {handleProjectsSchedulingMutation} from './projects_scheduling_mutation_success';
import {filterPersonsV4, filterProjectGroupsV4, filterTasksV4} from './projects_scheduling_filters';
import {getGroupsAndItemsFromProps, getTasksMap} from './projects_scheduling_data';
import {handleAutoSchedulingErrors} from './autoscheduling/handle_errors';
import {
	addFooterPerson,
	fetchPersonHeatmapData,
	getFilteredFooterPersons,
	handleFooterPersonMouseEnter,
	handleFooterPersonMouseLeave,
	onPersonMouseDown,
	removeFooterPerson,
	updateDropdownSearchCriteria,
} from './autoscheduling/footer_persons';
import {getAllocationData} from './projects_scheduling_allocation_data';
import {
	getDependencyChainTaskIdSet,
	getDependencyData,
	getRelevantDependencyTaskIdSet,
	onDependencyCreation,
} from './projects_scheduling_dependencies';
import {prepareAutoScheduleData} from './autoscheduling/prepare_autoscheduling_data';
import {disableSimulationMode, onApplySimulationChanges} from './autoscheduling/auto_scheduling_apply';
import Button from '../../../forecast-app/shared/components/buttons/button/button';
import {createHeader, getTopHeaderContent} from './projects_scheduling_header';
import {getProjectEyeOptions} from './projects_scheduling_options';
import {fetchData, fetchLightWeightData} from './projects_scheduling_fetch';
import {fetchInit} from '../scheduling_fetch';
import {fetchAutoSchedulingData} from './autoscheduling/auto_scheduling_fetch';
import {fetchAutoSchedulingProposal} from './autoscheduling/auto_scheduling_proposal';
import AiLoader from '../../loaders/ai_loader';
import {handleNotification} from './projects_scheduling_socket';
import {createLightWeightProjectsGroupsAndItems} from './projects_scheduling_lightweight';
import FreeDayItem from '../people-scheduling/items/freeday_item';
import {onAllocationContextMenu, onTaskContextMenu} from '../canvas_scheduling_context_menu';
import {getFilterFunctions} from '../../../forecast-app/shared/components/filters/filter_logic';
import TrackPersonEventMutation from '../../../mutations/track_person_event_mutation';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import {hasPermission, isClientUser, setPermissions} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';
import {getSubTasks, getTopParentId, isTaskInHierarchy} from './projects_scheduling_util';

class CanvasProjectsScheduling extends Component {
	constructor(props) {
		super(props);
		setTimestampCorrelationId();
		setTimestampLabel(props.isProjectTimeline ? 'Project Timeline' : 'Project Scheduling');

		const todayDate = getCanvasTimelineDateFromMoment(Moment());

		const labelFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-label')) || [];
		const projectFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-project')) || [];
		const clientFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-client')) || [];
		const roleFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-role')) || [];
		const projectStatusFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-projectStatus')) || [];
		const projectStageFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-projectStage')) || [];
		const personFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-person')) || [];
		const teamFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-team')) || [];

		this.state = {
			actionsMenuData: null,
			dataLoaded: false,
			simulationMode: false,
			assignedPersonHoverData: null,
			todayDate,
			footerPersons: [],
			footerPersonHoverData: null,
			autoSchedulingDropdownSearchCriteria: '',
			shouldShowScrollFade: false,
			timelineHeatmapData: this.props.timelineHeatmapData,
			isDraggingWholeDependencyChainModeOn: localStorage.getItem('isDraggingWholeDependencyChainModeOn') === 'true',
			labelFilterValue,
			projectFilterValue,
			clientFilterValue,
			roleFilterValue,
			projectStatusFilterValue,
			projectStageFilterValue,
			personFilterValue,
			teamFilterValue,
			searchFilterValue: '',
			splitAllocationBarData: {},
			showLoadingOverlay: false,
		};

		this.onSchedulingModalMutationSuccess = this.onSchedulingModalMutationSuccess.bind(this);
		subscribe(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, this.onSchedulingModalMutationSuccess);

		this.onClick = this.onClick.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.onKeyUp = this.onKeyUp.bind(this);
		this.onMouseMove = this.onMouseMove.bind(this);
		this.updateSimulationChangeMap = this.updateSimulationChangeMap.bind(this);
		this.onDistributionItemClick = this.onDistributionItemClick.bind(this);
		this.onTaskItemMouseEnter = this.onTaskItemMouseEnter.bind(this);
		this.onTaskItemMouseMove = this.onTaskItemMouseMove.bind(this);
		this.onTaskItemMouseLeave = this.onTaskItemMouseLeave.bind(this);
		this.onTaskItemMoving = this.onTaskItemMoving.bind(this);
		this.onTaskItemMoveEnd = this.onTaskItemMoveEnd.bind(this);
		this.onPersonImageLoad = this.onPersonImageLoad.bind(this);
		this.onTaskItemDraw = this.onTaskItemDraw.bind(this);

		this.personUtilizationCache = new Map();
		this.timelineHeatmapCache = new Map();

		this.visibleTaskData = [];

		this.onSavedFiltersUpdate = this.onSavedFiltersUpdate.bind(this);
		subscribe(EVENT_ID.SAVED_FILTERS_UPDATE, this.onSavedFiltersUpdate);
		this.handleSocketNotify = this.handleSocketNotify.bind(this);

		fetchInit(props.shareUrl).then(initData => {
			if (initData.projectSchedulingShare && initData.permissions) {
				setPermissions(initData.permissions);
			}

			this.setState(
				{
					initData,
				},
				() => {
					this.isUsing35Frames = this.state.initData.featureFlags.some(
						featureFlag => featureFlag.key === '3/5_zoom_frames'
					);
					this.isUsing67Frames = this.state.initData.featureFlags.some(
						featureFlag => featureFlag.key === '6/7_zoom_frames'
					);
					this.isUsingInstantZoom = this.state.initData.featureFlags.some(
						featureFlag => featureFlag.key === 'instant_zoom'
					);
					this.isUsingResourceService = this.state.initData.featureFlags.some(
						featureFlag => featureFlag.key === 'use_resource_service_in_scheduling'
					);

					if (!props.isProjectTimeline) {
						this.doFetchMinimalData(props);
					} else {
						this.doFetchFullData(props);
					}
				}
			);
		});
	}

	componentDidMount() {
		if (!this.props.sharedContext) {
			Util.CommitMutation(TrackPersonEventMutation, {
				name: 'scheduling-project',
			});
		}
		tracking.trackPage('scheduling-project');
		tracking.trackAppcuesEvent('scheduling-project-event');

		this.props.setTimeline(this.timeline);
		window.addEventListener('click', this.onClick);
		window.addEventListener('keyup', this.onKeyUp);
		window.addEventListener('mousemove', this.onMouseMove);
		document.body.addEventListener('keydown', this.onKeyDown);

		subscribe(EVENT_ID.SOCKET_NOTIFY, this.handleSocketNotify);

		this.personUtilizationWebWorker = new PersonUtilizationWebWorker();
		this.personUtilizationWebWorker.addEventListener('message', e => {
			const responseArray = e.data;
			for (const responseItem of responseArray) {
				const {taskId, isOverAllocated} = responseItem;

				const taskItem = this.state.items.find(
					item => item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK && item.data.task.id === taskId
				);
				if (taskItem) {
					const task = taskItem.data.task;

					task.isOverAllocated = isOverAllocated;
					this.personUtilizationCache.set(task, isOverAllocated);
				}
			}

			if (this.personUtilizationRedrawTimeout) {
				clearTimeout(this.personUtilizationRedrawTimeout);
			}
			this.personUtilizationRedrawTimeout = setTimeout(() => {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
			}, 300);
		});

		if (this.state.simulationMode) {
			this.runPersonUtilizationWebWorker();
			this.setScrollFade();
		}
	}

	componentDidUpdate() {
		if (this.state.dataFetched && this.state.movedItem) {
			this.onProjectItemMoveEnd(
				this.state.movedItem.item,
				this.state.movedItem.group,
				this.state.movedItem.initialGroup,
				this.state.movedItem.dragData
			);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.onClick);
		window.removeEventListener('keyup', this.onKeyUp);
		window.removeEventListener('mousemove', this.onMouseMove);
		document.body.removeEventListener('keydown', this.onKeyDown);
		unsubscribe(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, this.onSchedulingModalMutationSuccess);
		unsubscribe(EVENT_ID.SOCKET_NOTIFY, this.handleSocketNotify);

		if (this.state.simulationMode) {
			setSimulationMode(false);
		}
	}

	handleSocketNotify(dataList) {
		if (
			this.state.initData &&
			this.state.initData.featureFlags.some(flag => flag.key === 'use_push_on_projects_scheduling')
		) {
			handleNotification(this, dataList);
		}
	}

	createRelayTeamsDataStructure(data) {
		return [
			...data.teams.map(team => {
				return {
					node: {
						...team,
						id: btoa(`Team:${team.id}`),
						teamPersons: {
							edges: data.teamPersons
								.filter(tp => tp.teamId === team.id)
								.map(tp => {
									return {node: {...tp, person: {id: tp.personId}}};
								}),
						},
					},
				};
			}),
			{
				node: {
					id: null,
					teamPersons: {
						edges: data.teamPersons.map(tp => {
							return {node: {...tp, person: {id: tp.personId}}};
						}),
					},
				},
			},
		];
	}

	doFetchMinimalData(props) {
		fetchLightWeightData(props).then(lightWeightDataArray => {
			setTimestampDataLoaded();
			const lightWeightData = lightWeightDataArray[0];
			const timelineHeatmapData = lightWeightDataArray[1] || undefined;
			const projectId = props.match.params.projectId;
			const groupId = props.match.params.groupId;
			const shareUrl = props.match.params.shareUrl;
			if (
				!lightWeightData ||
				lightWeightData.error ||
				(props.isProjectTimeline &&
					!shareUrl &&
					!props.match.params.groupId &&
					(!timelineHeatmapData || timelineHeatmapData.error))
			) {
				showModal({
					type: MODAL_TYPE.MUTATION_ERROR,
					isNetworkError: false,
					reload_to_upcoming: true,
				});
			} else {
				lightWeightData.personMap = new Map(lightWeightData.persons.map(person => [person.id, person]));
				lightWeightData.projectMap = new Map(lightWeightData.projects.map(project => [project.id, project]));
				lightWeightData.projectPersonsByProject = _.groupBy(lightWeightData.projectPersons, 'projectId');
				lightWeightData.projectLabelsByProject = _.groupBy(lightWeightData.projectLabels, 'projectId');
				lightWeightData.projectStatusMap = new Map(
					lightWeightData.projectStatuses.map(projectStatus => [projectStatus.projectId, projectStatus])
				);
				lightWeightData.personLabelsByPerson = _.groupBy(lightWeightData.personLabels, 'personId');
				lightWeightData.personSkillsByPersonMap = _.groupBy(lightWeightData.personSkills, 'personId');
				lightWeightData.relayTeams = this.createRelayTeamsDataStructure(lightWeightData);
				if (isClientUser()) {
					this.props.history.push(
						props.isProjectTimeline
							? `/project/${props.match.params.projectGroupId ? 'X' : 'P'}-${
									props.match.params.projectGroupId || props.match.params.projectId
							  }/workflow`
							: '/'
					);
					return;
				}

				let projectTimelineProjectStatus = null;
				if (props.isProjectTimeline && props.match.params.projectId != null) {
					let project = lightWeightData.projects.find(
						p => p.companyProjectId.toString() === props.match.params.projectId
					);
					if (project) {
						projectTimelineProjectStatus = project.status;
					}
				}

				let isProjectTabSelected = this.state.isProjectTabSelected;
				if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) && !props.isProjectTimeline) {
					isProjectTabSelected = false;
				}

				let isShowingAutoScheduleOnLoad = window.location.hash === '#auto-schedule';
				let userCanAutoSchedule = true;
				if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
					isShowingAutoScheduleOnLoad = false;
					userCanAutoSchedule = false;
				}

				this.setState(
					{
						lightWeightData,
					},
					() => {
						const {groups, items} = createLightWeightProjectsGroupsAndItems(this, props, lightWeightData, true);

						this.setInitialExpansion(groups);
						// filter string needs to be different for project timeline because we want to be able to have different filters saved for each project
						const filterVersionString = 'canvas-scheduling-filters-v4';
						const filterString = projectId
							? `${filterVersionString}-projects-projectId-${projectId}`
							: groupId
							? `${filterVersionString}-projects-groupId-${groupId}`
							: `${filterVersionString}-projects`;

						let filters = {
							person: {},
							task: {},
							project: {},
						};
						if (!shareUrl && localStorage.getItem(filterString)) {
							filters = JSON.parse(localStorage.getItem(filterString));
						}

						const {viewer, company} = lightWeightData;

						const filterFunctions = getFilterFunctions(filters);

						this.setState(
							{
								viewer,
								lightweightDataLoaded: true,
								groups,
								items,
								filters,
								project: lightWeightData.projects.find(
									project => project.companyProjectId.toString() === this.props.projectId
								),
								isProjectTabSelected,
								projectTimelineProjectStatus,
								timelineHeatmapData,
								isShowingAutoScheduleOnLoad: isShowingAutoScheduleOnLoad,
								userCanAutoSchedule: userCanAutoSchedule,
								filterFunctions,
							},
							() => {
								this.projectEyeOptions = getProjectEyeOptions(
									props.isProjectTimeline,
									company.isUsingProjectAllocation
								);
								this.setState({
									projectSchedulingDetailSelectorOptions: this.projectEyeOptions,
								});
								dispatch(EVENT_ID.PAGE_LOADED, 'project_scheduling_minimal');
								this.doFetchFullData(props);
							}
						);
					}
				);
			}
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		});
	}

	doFetchFullData(props) {
		fetchData(props).then(dataArray => {
			const data = dataArray[0];
			const timelineHeatmapData = dataArray[1] || undefined;
			const projectId = props.match.params.projectId,
				groupId = props.match.params.groupId,
				shareUrl = props.match.params.shareUrl;
			if (
				!data ||
				data.error ||
				(!props.shareUrl &&
					props.isProjectTimeline &&
					!props.match.params.groupId &&
					(!timelineHeatmapData || timelineHeatmapData.error))
			) {
				showModal({
					type: MODAL_TYPE.MUTATION_ERROR,
					isNetworkError: false,
					reload_to_upcoming: true,
				});
			} else {
				data.persons.forEach(person => {
					person.startDate =
						this.isUsingResourceService && person.startDate
							? getCanvasTimelineDateFromMoment(moment.utc(person.startDate, 'YYYY-MM-DD'))
							: null;
					person.endDate =
						this.isUsingResourceService && person.endDate
							? getCanvasTimelineDateFromMoment(moment.utc(person.endDate, 'YYYY-MM-DD'))
							: null;
				});

				const {phaseIdToTaskIdsMap, taskIdToTaskMap, parentTaskToSubtaskMap} = getTasksMap(data);
				data.phaseIdToTaskIdsMap = phaseIdToTaskIdsMap;
				data.taskIdToTaskMap = taskIdToTaskMap;
				data.parentTaskToSubtaskMap = parentTaskToSubtaskMap;

				data.taskMap = new Map(data.tasks.map(task => [task.id, task]));
				data.personMap = new Map(data.persons.map(person => [person.id, person]));
				data.projectMap = new Map(data.projects.map(project => [project.id, project]));
				data.statusColumnMap = new Map(data.statusColumns.map(statusColumn => [statusColumn.id, statusColumn]));
				data.projectPersonsByProject = _.groupBy(data.projectPersons, 'projectId');
				data.projectLabelsByProject = _.groupBy(data.projectLabels, 'projectId');
				data.projectStatusMap = new Map(
					data.projectStatuses.map(projectStatus => [projectStatus.projectId, projectStatus])
				);
				data.personLabelsByPerson = _.groupBy(data.personLabels, 'personId');
				data.personSkillsByPersonMap = _.groupBy(data.personSkills, 'personId');
				data.allocationsByPerson = _.groupBy(data.allocations, 'personId');
				data.relayTeams = this.createRelayTeamsDataStructure(data);
				data.parentTimeRegistrationMap = new Map();
				for (const timeRegistration of data.timeRegistrations) {
					const id = timeRegistration.taskId || timeRegistration.projectId || timeRegistration.idleTimeId;
					const currentArray = data.parentTimeRegistrationMap.get(id) || [];
					currentArray.push(timeRegistration);
					data.parentTimeRegistrationMap.set(id, currentArray);
					timeRegistration.date = createCanvasTimelineDate(
						timeRegistration.year,
						timeRegistration.month,
						timeRegistration.day
					);
				}

				let projectTimelineProjectStatus = null;
				if (props.isProjectTimeline && props.match.params.projectId != null) {
					let project = data.projects.find(p => p.companyProjectId.toString() === props.match.params.projectId);
					if (project) {
						projectTimelineProjectStatus = project.status;
					}
				}

				let isProjectTabSelected = this.state.isProjectTabSelected;
				if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) && !props.isProjectTimeline) {
					isProjectTabSelected = false;
				}

				let isShowingAutoScheduleOnLoad = this.state.isShowingAutoScheduleOnLoad;
				if (isShowingAutoScheduleOnLoad === undefined) {
					isShowingAutoScheduleOnLoad = window.location.hash === '#auto-schedule';
				}
				let userCanAutoSchedule = true;
				if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
					isShowingAutoScheduleOnLoad = false;
					userCanAutoSchedule = false;
				}

				this.setState(
					{
						data,
						dataFetched: true,
						lightWeightData: null,
					},
					() => {
						const {viewer, company} = data;

						const {groups, items} = getGroupsAndItemsFromProps(this, props, data);

						this.setInitialExpansion(groups);

						let filters;
						const filterVersionString = 'canvas-scheduling-filters-v4';
						const filterString = projectId
							? `${filterVersionString}-projects-projectId-${projectId}`
							: groupId
							? `${filterVersionString}-projects-groupId-${groupId}`
							: `${filterVersionString}-projects`;

						if (!shareUrl && localStorage.getItem(filterString)) {
							filters = JSON.parse(localStorage.getItem(filterString));
						} else {
							filters = {
								person: {},
								task: {},
								project: {},
							};
						}

						const filterFunctions = getFilterFunctions(filters);

						const timelineCompanyProjectId = this.props.projectId
							? this.props.projectId
							: data.sharedProjectCompanyProjectId;
						const project = data.projects.find(
							project => project.companyProjectId.toString() === timelineCompanyProjectId
						);
						this.setState(
							{
								viewer,
								dataLoaded: true,
								groups,
								items,
								filters,
								savingMutation: false,
								project: project,
								dependencies: data.dependencies,
								isShowingProjectTimelineSimulationMode: false,
								isShowingAutoScheduleLoader: false,
								isProjectTabSelected,
								projectTimelineProjectStatus,
								timelineHeatmapData,
								isShowingAutoScheduleOnLoad: isShowingAutoScheduleOnLoad,
								userCanAutoSchedule: userCanAutoSchedule,
								filterFunctions,
							},
							() => {
								this.projectEyeOptions = getProjectEyeOptions(
									props.isProjectTimeline,
									company.isUsingProjectAllocation
								);
								this.setState({
									projectSchedulingDetailSelectorOptions: this.projectEyeOptions,
								});
								if (this.mutationResponse) {
									this.onSchedulingModalMutationSuccess(this.mutationResponse);
								}
								dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {
									preventFiltering: false,
									isInitialLoad: true,
								});
								dispatch(EVENT_ID.PAGE_LOADED, 'project_scheduling_full');
							}
						);
					}
				);
			}
		});
	}

	getData() {
		return this.state.data;
	}

	// function used by the old filter which is shared with people schedule scheduling_old_filter.js
	getFilterData() {
		return this.state.data ? this.state.data : this.state.lightWeightData;
	}

	showAutoSchedulingModal() {
		if (this.state.dataLoaded) {
			window.history.pushState('', document.title, window.location.pathname + window.location.search);
			tracking.trackElementClicked('Auto Schedule project from the project Timeline');

			const project = this.getData().projects.find(
				project => '' + project.companyProjectId === this.props.match.params.projectId
			);
			const phases = this.getData().phases.filter(phase => phase.projectId === project.id);
			const tasks = this.getData().tasks.filter(task => task.projectId === project.id);
			const projectPersons = this.getData().projectPersons;

			// array that will contain the phases that will not be scheduled
			let notQualifiedPhasesNames = [];
			// check if there are phases that do not contain any task or any approved tasks to show a warning
			for (let phase of phases) {
				if (!tasks.some(task => task.phaseId === phase.id && task.approved)) {
					notQualifiedPhasesNames.push(phase.name);
				}
			}

			showModal({
				type: MODAL_TYPE.AUTO_SCHEDULING,
				phases,
				tasks,
				projectPersons,
				companyPersons: this.state.data.persons,
				project,
				roles: this.state.data.roles,
				notQualifiedPhasesNames,
				onAutoSchedulingConfig: this.handleAutoScheduleProposalRequest.bind(this),
				fetchPersonHeatmapData: personIds => {
					fetchPersonHeatmapData(this, personIds).then(data => {
						this.setState({timelineHeatmapData: data});
					});
				},
			});

			// Fetch data needed on the preview screen. This is to give feedback on
			// over-allocation, when dragging tasks around.
			fetchAutoSchedulingData().then(data => {
				const stateData = this.state.data || {};
				stateData.allTasks = data.tasks;
				stateData.allTimeRegistrations = data.timeRegistrations;
				stateData.allAllocations = data.allocations;
				this.setState({data: stateData});
				this.runPersonUtilizationWebWorker();
			});
			this.setState({
				loadingAutoSchedule: false,
				showLoader: false,
			});
		} else {
			this.setState({
				loadingAutoSchedule: true,
				showLoader: true,
			});
		}
	}

	onRescheduleButtonPress() {
		this.handleAutoScheduleProposalRequest(this.state.autoSchedulingConfig);
	}

	handleAutoScheduleProposalRequest(autoSchedulingConfig) {
		const {formatMessage} = this.props.intl;

		this.setState({isShowingAutoScheduleLoader: true});
		return fetchAutoSchedulingProposal(autoSchedulingConfig).then(autoScheduleProposalData => {
			if (autoScheduleProposalData.status !== 200) {
				return;
			}
			setSimulationMode(true);

			const {
				extraPersonsAdded,
				autoSchedulingRequestConfig: {personRole},
			} = autoSchedulingConfig;

			const {groups, items} = this.state;
			const originalItems = [...items];

			const autoScheduleProjectTeam = personRole.map(personRole => ({
				personId: btoa('Person:' + personRole.personId),
				roleId: personRole.roleId ? btoa('Role:' + personRole.roleId) : null,
			}));

			const {autoSchedulingErrors, footerPersons, footerWarnings, simulationChangeMap} = prepareAutoScheduleData(
				this,
				autoScheduleProposalData,
				autoScheduleProjectTeam,
				groups,
				items
			);

			this.setState(
				{
					originalItems,
					simulationMode: true,
					isShowingAutoScheduleLoader: false,
					isShowingProjectTimelineSimulationMode: true,
					autoScheduleProposalData,
					autoSchedulingConfig,
					autoSchedulingErrors,
					footerPersons,
					footerWarnings,
					simulationChangeMap,
					autoScheduleProjectTeam,
				},
				() => {
					this.setInitialExpansion(groups);
					this.timeline.setInitialZoomLevel();
				}
			);

			if (extraPersonsAdded && extraPersonsAdded.length) {
				//Show modal telling user that extra persons were added to the project
				showModal({
					type: MODAL_TYPE.GENERIC,
					className: 'auto-schedule-extra-persons',
					content: (
						<FormattedMessage
							id="auto_scheduling.modal.extra_people_added"
							values={{
								numOfPeople: extraPersonsAdded.length,
								people: (
									<strong>
										<ul>
											{extraPersonsAdded.map(person => (
												<li>{person.fullName}</li>
											))}
										</ul>
									</strong>
								),
							}}
						/>
					),
					buttons: [
						{
							text: formatMessage({id: 'common.ok'}),
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
					],
				});
			}

			if (autoSchedulingErrors && autoSchedulingErrors.length !== 0) {
				handleAutoSchedulingErrors(this, autoSchedulingErrors);
			}
		});
	}

	setScrollFade() {
		// Is content scrollable
		if (this.scrollbar) {
			const offset = -20;
			const scrollWidth = this.scrollbar.scrollbars.getScrollWidth() + offset;
			const divWidth = this.scrollbar.scrollbars.getClientWidth() + offset;

			if (scrollWidth > divWidth) {
				if (!this.state.shouldShowScrollFade) {
					this.setState({shouldShowScrollFade: true});
				}
			} else {
				if (this.state.shouldShowScrollFade) {
					this.setState({shouldShowScrollFade: false});
				}
			}
		}
	}

	scroll(value) {
		this.timeline.scroll(value, {applyEasing: true});
	}

	scrollToToday() {
		this.timeline.scrollToToday(0.25);
	}

	onSavedFiltersUpdate(response) {
		const stateData = this.getFilterData();
		if (response.createFilter) {
			if (this.props.isProjectTimeline) {
				if (this.state.data) {
					const newFilter = {
						id: response.createFilter.filter.node.id,
						name: response.createFilter.filter.node.name,
						section: response.createFilter.filter.node.section,
						value: response.createFilter.filter.node.value,
						personId: this.state.data.viewer.actualPersonId,
						projectId: this.state.data.project ? this.state.data.project.id : null,
						projectGroupId: this.state.data.projectGroup ? this.state.projectGroup.id : null,
					};
					stateData.projectTimelineFilters.push(newFilter);
				}
			} else {
				stateData.projectFilters.push(response.createFilter.filter.node);
			}
			this.setState({data: stateData});
		} else if (response.updateFilter) {
			this.setState({data: stateData});
		} else if (response.deleteFilter) {
			if (this.props.isProjectTimeline) {
				stateData.projectTimelineFilters = stateData.projectTimelineFilters.filter(
					filter => filter.id !== response.deleteFilter.deletedFilterId
				);
			} else {
				stateData.projectFilters = stateData.projectFilters.filter(
					filter => filter.id !== response.deleteFilter.deletedFilterId
				);
			}
			this.setState({data: stateData});
		}
	}

	handleMoveDateButtonClick(moveForward) {
		if (moveForward) {
			this.scroll(0.33);
		} else {
			this.scroll(-0.33);
		}
	}

	onSearchChange(e) {
		//new navigation returns string in parameter
		const value = e.target ? e.target.value : e;
		this.setState({searchFilterValue: value}, () => {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		});
	}

	/**
	 * Don't remove this method. It is invoked from scheduling_old_filter.js
	 */
	onFilterChange() {}

	onDrawForegroundStart() {
		this.previousVisibleTaskDataLength = this.visibleTaskData.length;
		this.visibleTaskData = [];
		this.relevantDependencyTaskIdSet = null;
	}

	onDrawForegroundEnd(context, mouseTargetData) {
		const {autoSchedulingDragPersonId} = this.state;
		const {itemData} = mouseTargetData;
		if (autoSchedulingDragPersonId && itemData && itemData.item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK) {
			drawRectangle(context, itemData.x - GROUP_SECTION_WIDTH, itemData.y, itemData.width, itemData.height, {
				backgroundOpacity: 0,
				borderThickness: 2,
				borderColor: this.state.project && this.state.project.projectColor,
				isCornerTopRightCutOff: true,
			});
			const cachedImage = cacheManager.get('personImage', autoSchedulingDragPersonId);
			let img = null;

			if (cachedImage) {
				img = cachedImage;
			} else {
				const person = this.getData().persons.find(person => person.id === autoSchedulingDragPersonId);
				if (person.profilePictureId) {
					img = new Image();
					img.onload = () => {
						cacheManager.set('personImage', autoSchedulingDragPersonId, img);
						this.onPersonImageLoad();
					};
					img.src = profilePicSrc(person.profilePictureId);
				} else {
					const initialsXCoor = itemData.x - GROUP_SECTION_WIDTH + itemData.width;
					drawHexagon(context, initialsXCoor, itemData.y, itemData.height, '#6e0fea', 1);

					context.font = '500 11px ' + Util.getFontFamily();
					context.fillStyle = 'white';
					context.textAlign = 'center';
					context.fillText(person.initials.toUpperCase(), initialsXCoor + 12, itemData.y + 18);
					context.textAlign = 'start';
				}
			}

			img &&
				context.drawImage(
					img,
					itemData.x - GROUP_SECTION_WIDTH + itemData.width,
					itemData.y,
					AUTO_SCHEDULING_PERSON_WIDTH,
					itemData.height
				);
		}
	}

	onMouseMoveEnd(mouseTargetData) {
		const {autoSchedulingDragPersonId} = this.state;
		const {itemData} = mouseTargetData;
		const lastHoveredItem = this.lastHoveredItem;
		const hoveredItem = itemData ? itemData.item : undefined;
		if (autoSchedulingDragPersonId && lastHoveredItem !== hoveredItem) {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}
		this.lastHoveredItem = hoveredItem;
	}

	getCalculationPeriod() {
		const calculationPeriodArray = [];
		for (const visibleTaskData of this.visibleTaskData) {
			const task = visibleTaskData.task;
			if (!task.autoSchedulingPerson) continue;

			const startDate = createCanvasTimelineDate(task.startYear, task.startMonth, task.startDay);
			const endDate = createCanvasTimelineDate(task.deadlineYear, task.deadlineMonth, task.deadlineDay);

			const exists = calculationPeriodArray.some(
				period =>
					period.startDate === startDate &&
					period.endDate === endDate &&
					period.task.autoSchedulingPerson.id === task.autoSchedulingPerson.id
			);

			if (exists) continue;

			calculationPeriodArray.push({startDate, endDate, task});
		}

		return calculationPeriodArray;
	}

	runPersonUtilizationWebWorker() {
		const todayDate = this.state.todayDate;
		const isInActualMode =
			!this.getData().company.isUsingSchedulingPlanMode && !this.getData().company.isUsingProjectAllocation;
		const calculationPeriodArray = this.getCalculationPeriod();

		// If we have fetched all the data
		if (this.getData().allTasks) {
			// Run the web worker
			setTimeout(() => {
				this.personUtilizationWebWorker.postMessage({
					calculationPeriodArray,
					allocations: this.getData().allocations,
					projects: this.getData().projects.map(project => ({
						id: project.id,
						useManualAllocations: project.useManualAllocations,
						projectGroupId: project.projectGroupId,
						minutesPerEstimationPoint: project.minutesPerEstimationPoint,
						estimationUnit: project.estimationUnit,
					})),
					timeRegistrations: this.getData().timeRegistrations,
					tasks: this.getData().tasks,
					holidayCalendars: this.getData().holidayCalendars,
					holidayCalendarEntries: this.getData().holidayCalendarEntries,
					company: this.getData().company,
					todayDate,
					isInActualMode,
					idleTimes: this.getData().idleTimes,
					allTasks: this.getData().allTasks,
					allTimeRegistrations: this.getData().allTimeRegistrations,
					allAllocations: this.getData().allAllocations,
				});
			}, 200);
		}
	}

	getVisibleTasksInHierarchy(task) {
		const {parentTaskToSubtaskMap, tasks, taskMap} = this.state.data;
		if (isTaskInHierarchy(task, parentTaskToSubtaskMap)) {
			const topParentId = getTopParentId(taskMap, task);
			const topParent = taskMap.get(topParentId);
			const tasksHierarchyIds = getSubTasks(parentTaskToSubtaskMap, tasks, topParent).map(task => {
				return task.id;
			});

			tasksHierarchyIds.push(topParentId);

			return tasksHierarchyIds
				? this.visibleTaskData.filter(item => {
						return tasksHierarchyIds.includes(item.task.id);
				  })
				: [];
		}
	}

	onMouseUpEnd(mouseTargetData) {
		const {autoSchedulingDragPersonId, simulationChangeMap, items} = this.state;
		if (autoSchedulingDragPersonId) {
			if (
				mouseTargetData &&
				mouseTargetData.itemData &&
				mouseTargetData.itemData.item &&
				mouseTargetData.itemData.item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK
			) {
				simulationChangeMap
					.get('persons')
					.set(mouseTargetData.itemData.item.data.task.id, [autoSchedulingDragPersonId]);

				const taskItem = items.find(
					item =>
						item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK &&
						item.data.task.id === mouseTargetData.itemData.item.data.task.id
				);
				const person = this.getData().persons.find(person => person.id === autoSchedulingDragPersonId);
				if (taskItem) {
					const task = taskItem.data.task;
					if (task.autoSchedulingPerson) {
						this.timelineHeatmapCache.delete(task.autoSchedulingPerson.id);
					}
					task.autoSchedulingPerson = person;
					taskItem.horizontalExtension = 26;
					this.timelineHeatmapCache.delete(person.id);
				}

				this.runPersonUtilizationWebWorker();
			}
			requestAnimationFrame(() => {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
			});

			this.setState({
				autoSchedulingDragPersonId: null,
				autoSchedulingDragTranslateX: null,
				autoSchedulingDragTranslateY: null,
				simulationChangeMap,
			});
		}
	}

	onGroupExpansionToggle(group) {
		if (group) {
			//Store expansion status so that we can keep track of it when switching between tabs
			this.props.expansionMap.set(group.id, group.expanded);
		}
		if (
			group.groupType === GROUP_TYPE.PROJECT_SCHEDULING_PROJECT &&
			!group.data.isConnectedProject &&
			!group.groups[0].expanded &&
			this.props.expansionMap.get(group.groups[0].id) === undefined
		) {
			this.props.expansionMap.set(group.groups[0].id, true);
			group.groups[0].toggleExpansion();
		}
		//Ensure that if a new dependency appeared on the screen upon expansion, we redraw the timeline so that it shows all tasks within that dependency chain
		if (this.groupExpansionToggleRedrawFrame) return;
		this.groupExpansionToggleRedrawFrame = requestAnimationFrame(() => {
			if (this.visibleTaskData.length !== this.previousVisibleTaskDataLength) {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
			}
			this.groupExpansionToggleRedrawFrame = null;
		});
	}

	onTaskItemDraw(task, x, y, width, height) {
		// Add cursor pointer to the person image
		if (task.autoSchedulingPerson) {
			interactionManager.addCursorStyleArea(
				x + GROUP_SECTION_WIDTH + width,
				y,
				AUTO_SCHEDULING_PERSON_WIDTH,
				height,
				CURSOR.POINTER
			);
		}
		this.visibleTaskData.push({id: task.id, task, x, y, width, height});
	}

	setInitialExpansion(groups) {
		const {simulationMode} = this.state;
		if (this.props.expansionMap && this.props.expansionMap.size) {
			const processGroup = group => {
				const shouldChangeGroup =
					(this.props.expansionMap.get(group.id) ||
						(simulationMode && group.data.id.includes('team-members')) ||
						false) !== group.expanded; //if simulation mode is active, expand all the milestones expect for the ones that are set not to be expanded
				if (shouldChangeGroup) {
					group.toggleExpansion();
				}

				if (group.groups) {
					for (const childGroup of group.groups) {
						if (!childGroup.parentGroup) {
							childGroup.parentGroup = group;
						}
						processGroup(childGroup);
					}
				}
			};
			for (const group of groups) {
				processGroup(group);
			}
			requestAnimationFrame(() => {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
			});
			return;
		}

		if (this.props.isProjectTimeline) {
			// Expands the timeline by n number of levels by default
			// When in simulation mode, all the levels are expanded
			const defaultProjectNestLevel = simulationMode ? 3 : 2;
			const defaultConnectedProjectNestLevel = simulationMode ? 4 : 3;

			const maxNestLevel = this.props.groupId ? defaultConnectedProjectNestLevel : defaultProjectNestLevel;
			const processGroup = (group, nestLevel) => {
				if (nestLevel >= maxNestLevel || (!simulationMode && group.id.includes('team-members'))) return;

				const shouldChangeGroup = !group.expanded;
				if (shouldChangeGroup) {
					group.toggleExpansion();
					this.onGroupExpansionToggle(group);
				}

				if (group.groups) {
					for (const childGroup of group.groups) {
						if (!childGroup.parentGroup) {
							childGroup.parentGroup = group;
						}
						processGroup(childGroup, nestLevel + 1);
					}
				}
			};
			for (const group of groups) {
				processGroup(group, 0);
			}
		}
	}

	getProjectGroups() {
		const {groups} = this.state;
		const groupArray = [];
		for (const group of groups) {
			if (group.data.isConnectedProject) {
				for (const projectGroup of group.groups) {
					groupArray.push(projectGroup);
				}
			} else {
				groupArray.push(group);
			}
		}
		return groupArray;
	}

	onSchedulingModalMutationSuccess(response) {
		const data = this.getData();
		if (!data) {
			this.mutationResponse = response;
			this.setState({savingMutation: true});
			return;
		}
		handleProjectsSchedulingMutation(this, response);
	}

	onHeatMapItemClicked(projectId, personId, startDate, endDate, projectMinutesAllocated, minutesAvailable) {
		const data = this.getData();

		const person = data.persons.find(person => person.id === personId);

		tracking.trackEvent('Show Person utilization modal');
		showModal({
			type: MODAL_TYPE.STANDALONE_CANVAS_UTILIZATION,
			projectId,
			startDate,
			endDate,
			person,
			company: data.company,
			projects: data.allProjects ? data.allProjects : data.projects,
			projectGroups: data.projectGroups,
			projectPersons: data.projectPersons,
			holidayCalendars: data.holidayCalendars,
			holidayCalendarEntries: data.holidayCalendarEntries,
			actualPersonId: data.viewer.actualPersonId,
			availableFeatureFlags: data.viewer.availableFeatureFlags,
			idleTimes: data.idleTimes,
			projectMinutesAllocated,
			minutesAvailable,
			isPast: endDate < this.state.todayDate,
		});
	}

	constructCanvasItem(type, {group, stepData, isToday, onClick, minutesAllocated, minutesAvailable}) {
		const {intl} = this.props;
		if (type === 'freeday') {
			return new FreeDayItem({
				y: group.screenY,
				x: stepData.position,
				width: stepData.width,
				groupHeight: group.totalHeight,
				isToday,
				onClick,
			});
		} else if (type === 'timeoff') {
			return new TimeOffItem({
				y: group.screenY,
				x: stepData.position,
				width: stepData.width,
				groupHeight: group.totalHeight,
				isToday,
				onClick,
				intl,
			});
		} else if (type === 'utilization') {
			return new HeatmapItem({
				y: group.screenY,
				x: stepData.position,
				intl,
				width: stepData.width,
				minutesAllocated,
				minutesAvailable,
				groupHeight: group.totalHeight,
				isToday,
				onClick,
				isProjectTimeline: true,
				eyeOptions: this.state.projectSchedulingDetailSelectorOptions,
				isPast: stepData.endDate < this.state.todayDate,
				isInActualMode:
					!this.getFilterData().company.isUsingSchedulingPlanMode &&
					!this.getFilterData().company.isUsingProjectAllocation,
			});
		}
	}

	composePersonHeatmap(group, stepDataArray, timelineStartDate, pixelsPerDay, timelineMinorStep) {
		const person = group.data;
		const {items, todayDate, project} = this.state;
		const {dayData} = this.props;
		const data = this.getData();
		let isInActualMode = !data.company.isUsingSchedulingPlanMode && !data.company.isUsingProjectAllocation;
		const {personId, workingHours} = person;
		const heatmapItems = [];
		if (!this.state.timelineHeatmapData[personId]) {
			let timelineHeatmapData = this.state.timelineHeatmapData;
			timelineHeatmapData[personId] = [];
			this.setState({
				timelineHeatmapData: timelineHeatmapData,
			});
		}
		const personHeatmapData = this.state.timelineHeatmapData[personId];
		const personWorkingMinutes = [
			workingHours.monday,
			workingHours.tuesday,
			workingHours.wednesday,
			workingHours.thursday,
			workingHours.friday,
			workingHours.saturday,
			workingHours.sunday,
		];
		const {holidaysIncludingDaysOff, holidaysExcludingDaysOff} = getHolidayDates(person, data, personWorkingMinutes);

		//Initialize heatmapCache if it does not exist
		if (!this.timelineHeatmapCache.has(personId)) {
			this.timelineHeatmapCache.set(personId, new Map());
		}

		const canvasTimeRegs = data.timeRegistrations.filter(timeReg => timeReg.personId === person.personId);
		// Create a map of timeregs sorted by taskid
		const taskTimeRegMap = data.timeRegistrations
			.filter(timeReg => timeReg.taskId)
			.reduce((map, timeReg) => {
				if (map[timeReg.taskId]) {
					map[timeReg.taskId].push(timeReg);
				} else {
					map[timeReg.taskId] = [timeReg];
				}
				return map;
			}, {});
		const getHolidayCountInPeriod = (periodStartDate, periodEndDate) => {
			return holidaysExcludingDaysOff.filter(date => {
				return date >= periodStartDate && date <= periodEndDate;
			}).length;
		};

		// Find items that are relevant to the stepDataArray
		const firstStartDate = stepDataArray[0].startDate;
		const lastEndDate = stepDataArray[stepDataArray.length - 1].endDate;
		const relevantItems = items.filter(item => {
			if (item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK) {
				// TASK ITEMS
				if (isSimulationMode()) {
					return item.data.task.autoSchedulingPerson ? item.data.task.autoSchedulingPerson.id === personId : false;
				} else {
					return (
						item.data.task.assignedPersons.includes(personId) &&
						!(item.startDate > lastEndDate || item.endDate < firstStartDate)
					);
				}
			}
			return false;
		});

		for (const stepData of stepDataArray) {
			let minutesAllocated = 0;
			let projectMinutesAllocated = 0;
			let {startDate, endDate} = stepData;

			const dateString = `${personId}-${timelineMinorStep}-${startDate}-${isInActualMode}`;
			const personCache = this.timelineHeatmapCache.get(personId);
			const cachedItem = personCache.get(dateString);
			if (cachedItem) {
				if (
					(person.startDate !== null && person.startDate > endDate) ||
					(person.endDate !== null && person.endDate < startDate)
				) {
					heatmapItems.push(
						this.constructCanvasItem('freeday', {
							group,
							stepData,
							isToday: todayDate === startDate,
							onClick: this.onHeatMapItemClicked.bind(
								this,
								project.id,
								personId,
								startDate,
								endDate,
								cachedItem.projectMinutesAllocated,
								cachedItem.minutesAvailable
							),
						})
					);
				} else if (cachedItem.minutesAvailable <= 0 && cachedItem.minutesAllocated <= 0) {
					if (
						!(stepData.isWeekend || (timelineMinorStep === 'day' && holidaysExcludingDaysOff.includes(startDate)))
					) {
						// if not weekend nor freeday its timeoff
						heatmapItems.push(
							this.constructCanvasItem('timeoff', {
								group,
								stepData,
								isToday: todayDate === startDate,
								onClick: this.onHeatMapItemClicked.bind(this, project.id, personId, startDate, endDate, 0, 0),
							})
						);
					}
				} else {
					heatmapItems.push(
						this.constructCanvasItem('utilization', {
							group,
							stepData,
							minutesAllocated: cachedItem.minutesAllocated,
							minutesAvailable: cachedItem.minutesAvailable,
							isToday: todayDate >= startDate && todayDate <= endDate,
							onClick: this.onHeatMapItemClicked.bind(
								this,
								project.id,
								personId,
								startDate,
								endDate,
								cachedItem.projectMinutesAllocated,
								cachedItem.minutesAvailable
							),
						})
					);
				}
				continue;
			}

			const weekdaysInPeriod = getWeekdaysBetweenDates(startDate, endDate);
			for (const holidayDate of holidaysIncludingDaysOff.filter(date => date >= startDate && date <= endDate)) {
				weekdaysInPeriod[dayData[holidayDate].isoWeekday - 1]--;
			}
			for (let canvasDate = startDate; canvasDate <= endDate; canvasDate++) {
				if (!isDateWithinPersonStartEndDate(person, canvasDate)) {
					weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] = Math.max(
						weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] - 1,
						0
					);
				}
			}
			let minutesAvailable = getMinutesInWeekdays(workingHours, weekdaysInPeriod);

			let relevantDataRange;
			for (let i = startDate; i <= endDate; i++) {
				// If we dont have a relevant date range yet, or the current date range's enddate is before our loop date "i"
				if (!relevantDataRange || (relevantDataRange[1] !== null && relevantDataRange[1] < i)) {
					// Find new relevant date range
					relevantDataRange = personHeatmapData.find(
						dataArray =>
							(dataArray[1] >= i && dataArray[0] === null) ||
							(dataArray[1] >= i && dataArray[0] <= i) ||
							(dataArray[1] === null && dataArray[0] <= i)
					);
				}
				if (relevantDataRange) {
					minutesAllocated += relevantDataRange[2];
					// Calc the persons minutes available for this day
					const minutesAvailableForDay = holidaysIncludingDaysOff.includes(i)
						? 0
						: personWorkingMinutes[dayData[i].isoWeekday - 1];
					minutesAvailable -= Math.min(relevantDataRange[3], minutesAvailableForDay); // Subtract timeoff from available. Limit to minutesAvailableForDay.
				}
			}
			minutesAvailable = Math.max(minutesAvailable, 0); // Available may never be negative

			// Add the data from the timeline project / autoschedule simulation
			for (const item of relevantItems) {
				if (item.startDate > endDate || item.endDate < startDate) continue;
				if (item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_PROJECT_ALLOCATION) {
					if (project.useManualAllocations) {
						const calculationStartDate = isInActualMode ? Math.max(todayDate, item.startDate) : item.startDate;
						const weekdaysInPeriod = getWeekdaysBetweenDates(
							Math.max(startDate, calculationStartDate),
							Math.min(endDate, item.endDate)
						);
						for (const holidayCalendarEntryDate of holidaysIncludingDaysOff.filter(
							date => date >= Math.max(startDate, calculationStartDate) && date <= Math.min(endDate, item.endDate)
						)) {
							//Remove a weekday if there is one, don't reduce if it is already at 0
							if (weekdaysInPeriod[this.props.dayData[holidayCalendarEntryDate].isoWeekday - 1]) {
								weekdaysInPeriod[this.props.dayData[holidayCalendarEntryDate].isoWeekday - 1]--;
							}
						}
						const allocationMinutes = getMinutesInWeekdays(item.data.allocation, weekdaysInPeriod);
						minutesAllocated += allocationMinutes;
					}
				} else if (item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK) {
					if (project.useManualAllocations) continue; //Don't care about tasks in project allocation projects

					const task = item.data.task;
					if (isInActualMode && task.done) continue; //Ignore done tasks in Actual mode
					const taskAssignedPersonsLength = !isSimulationMode()
						? task.assignedPersons.length
						: task.autoSchedulingPerson
						? 1
						: 0;
					const taskEndDate = item.endDate;
					const taskTimeRegs = taskTimeRegMap[task.id];
					const taskProject = data.projects.find(project => project.id === task.projectId);

					//Add to minutes allocated based on number of assignees and scheduling mode (actual mode uses timereg in the past and remaining vs estimate)
					let taskAllocationMinutes = Math.round(
						isInActualMode
							? taskProject.estimationUnit === ESTIMATION_UNIT.POINTS
								? task.timeLeft * taskProject.minutesPerEstimationPoint
								: task.timeLeft
							: task.estimateForecastMinutes
					);

					// In actual mode, we need to add future timeregistrations to the task time left, but only if the task stretches past today... dont ask me why :/
					if (isInActualMode && taskTimeRegs) {
						let totalMinutesRegistered = 0;
						let futureMinutesRegistered = 0;
						for (const taskTimeReg of taskTimeRegs) {
							if (taskTimeReg.date >= todayDate && taskEndDate >= todayDate) {
								futureMinutesRegistered += taskTimeReg.minutesRegistered;
							}
							totalMinutesRegistered += taskTimeReg.minutesRegistered;
						}
						// If remaining wasn't manually set, calculate it
						if (
							taskProject &&
							taskProject.remainingAutoCalculated &&
							(taskProject.taskLevels !== 2 || task.subTaskCount === 0)
						) {
							let estimate = task.estimateForecast;
							if (taskProject.estimationUnit === ESTIMATION_UNIT.POINTS) {
								estimate *= taskProject.minutesPerEstimationPoint;
							}
							taskAllocationMinutes = estimate - totalMinutesRegistered + futureMinutesRegistered;
						}
					}
					if (taskAllocationMinutes <= 0) continue; // Skip if task has no minutes to allocate

					const calculationStartDate = isInActualMode ? Math.max(todayDate, item.startDate) : item.startDate;

					//How many weekdays are in the task (ex: 1 monday, 1 tuesday, 1 wednesday)
					const taskTotalWeekdays = getWeekdaysBetweenDates(calculationStartDate, taskEndDate);
					//Weekdays which are within the current loop period
					const taskLoopWeekdays = getWeekdaysBetweenDates(
						Math.max(calculationStartDate, startDate),
						Math.min(taskEndDate, endDate)
					);

					//Total length of task in days minus days on which the person is supposed to work 0 minutes
					const taskWorkingDayCount =
						taskTotalWeekdays.reduce((total, weekdayCount, index) => {
							return total + (personWorkingMinutes[index] ? weekdayCount : 0);
						}, 0) - getHolidayCountInPeriod(calculationStartDate, taskEndDate);

					//If there are any working days during the task's period, spread timeLeft evenly among working days only
					//If there are no working days during the task's period, spread timeLeft evenly among all days
					//Always divide by amount of people assigned
					if (taskWorkingDayCount) {
						//Number of days within current loop period minus days on which the person is supposed to work 0 minutes
						const taskLoopWorkingDayCount =
							taskLoopWeekdays.reduce((total, weekdayCount, index) => {
								return total + (personWorkingMinutes[index] ? weekdayCount : 0);
							}, 0) -
							getHolidayCountInPeriod(Math.max(calculationStartDate, startDate), Math.min(taskEndDate, endDate));
						const taskMinutesAllocated =
							(taskAllocationMinutes * taskLoopWorkingDayCount) / taskWorkingDayCount / taskAssignedPersonsLength;
						projectMinutesAllocated += taskMinutesAllocated;
					} else {
						//Total length of task in days
						const taskTotalDayCount = taskTotalWeekdays.reduce((total, weekdayCount) => total + weekdayCount, 0);
						if (taskTotalDayCount > 0) {
							//Number of days within current loop period
							const taskLoopTotalDayCount = taskLoopWeekdays.reduce(
								(total, weekdayCount) => total + weekdayCount,
								0
							);
							const taskMinutesAllocated =
								(taskAllocationMinutes * taskLoopTotalDayCount) / taskTotalDayCount / taskAssignedPersonsLength;
							projectMinutesAllocated += taskMinutesAllocated;
						}
					}
				}
			}
			// In actual mode, add past Time regs
			if (isInActualMode) {
				canvasTimeRegs
					.filter(timeReg => timeReg.taskId || timeReg.projectId)
					.forEach(timeReg => {
						if (timeReg.date >= startDate && timeReg.date <= endDate && timeReg.date < todayDate) {
							projectMinutesAllocated += timeReg.minutesRegistered;
						}
					});
			}

			minutesAllocated += projectMinutesAllocated;

			this.timelineHeatmapCache.get(personId).set(dateString, {
				minutesAllocated,
				minutesAvailable,
				projectMinutesAllocated,
			});

			if (
				(person.startDate !== null && person.startDate > endDate) ||
				(person.endDate !== null && person.endDate < startDate)
			) {
				heatmapItems.push(
					this.constructCanvasItem('freeday', {
						group,
						stepData,
						isToday: todayDate === startDate,
						onClick: this.onHeatMapItemClicked.bind(
							this,
							project.id,
							personId,
							startDate,
							endDate,
							projectMinutesAllocated,
							minutesAvailable
						),
					})
				);
			} else if (minutesAvailable <= 0 && minutesAllocated <= 0) {
				if (!(stepData.isWeekend || (timelineMinorStep === 'day' && holidaysExcludingDaysOff.includes(startDate)))) {
					// if not weekend nor freeday its timeoff
					heatmapItems.push(
						this.constructCanvasItem('timeoff', {
							group,
							stepData,
							isToday: todayDate === startDate,
							onClick: this.onHeatMapItemClicked.bind(this, project.id, personId, startDate, endDate, 0, 0),
						})
					);
				}
			} else {
				heatmapItems.push(
					this.constructCanvasItem('utilization', {
						group,
						stepData,
						minutesAllocated,
						minutesAvailable,
						isToday: todayDate >= startDate && todayDate <= endDate,
						onClick: this.onHeatMapItemClicked.bind(
							this,
							project.id,
							personId,
							startDate,
							endDate,
							projectMinutesAllocated,
							minutesAvailable
						),
					})
				);
			}
		}
		return heatmapItems;
	}

	createPersonGroup(person, project, roleId, roleName, groupId, color, projectGroupContainsOnlyHaltedOrDoneProjects) {
		const {isProjectTimeline, sharedContext} = this.props;
		const data = this.getData();
		if (!data) {
			return;
		}

		const isDoneOrHalted = ['HALTED', 'DONE'].includes(project.status);
		const shouldSeeHeatmap = isProjectTimeline && hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) && !this.props.groupId;
		const isUsingProjectAllocation = data.company.isUsingProjectAllocation;

		const personGroupData = {
			id: groupId || project.id + '-' + person.id,
			groupIds: [`${person.id}-2`, groupId || project.id + '-' + person.id],
			firstName: person.firstName == null ? '' : person.firstName,
			lastName: person.lastName == null ? '' : person.lastName,
			startDate: person.startDate,
			endDate: person.endDate,
			profilePictureId: person.profilePictureId,
			profilePictureDefaultId: person.profilePictureDefaultId,
			roleId: roleId,
			role: roleName,
			color: color || project.projectColor,
			personId: person.id,
			holidayCalendarId: person.holidayCalendarId,
			workingHours: {
				monday: person.monday,
				tuesday: person.tuesday,
				wednesday: person.wednesday,
				thursday: person.thursday,
				friday: person.friday,
				saturday: person.saturday,
				sunday: person.sunday,
			},
			departmentId: person.departmentId,
			composeItems: isUsingProjectAllocation
				? undefined
				: shouldSeeHeatmap
				? this.composePersonHeatmap.bind(this)
				: this.composeTaskAllocation.bind(this, person.id, project),
			onPersonImageLoad: this.onPersonImageLoad.bind(this),
			filterGroup: filterPersonsV4.bind(this, this),
			onItemCreate:
				projectGroupContainsOnlyHaltedOrDoneProjects ||
				!isUsingProjectAllocation ||
				!hasPermission(PERMISSION_TYPE.ALLOCATION_CREATE) ||
				sharedContext ||
				(project.isInProjectGroup ? projectGroupContainsOnlyHaltedOrDoneProjects : isDoneOrHalted)
					? undefined
					: (startDate, endDate) => {
							const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
							const momentEndDate = getMomentFromCanvasTimelineDate(endDate);

							showModal({
								type: MODAL_TYPE.CANVAS_CREATE,
								projectGroups: data.projectGroups,
								projects: data.projects,
								idleTimes: data.idleTimes,
								projectPersons: data.projectPersons,
								actualPersonId: data.viewer.actualPersonId,
								persons: data.persons,
								selectedPersonId: person.id,
								selectedProject: project,
								milestones: data.phases,
								company: data.company,
								holidayCalendars: data.holidayCalendars,
								holidayCalendarEntries: data.holidayCalendarEntries,
								allocation: {
									personId: person.id,
									startDay: momentStartDate.date(),
									startMonth: momentStartDate.month() + 1,
									startYear: momentStartDate.year(),
									endDay: momentEndDate.date(),
									endMonth: momentEndDate.month() + 1,
									endYear: momentEndDate.year(),
									monday: person.monday,
									tuesday: person.tuesday,
									wednesday: person.wednesday,
									thursday: person.thursday,
									friday: person.friday,
									saturday: person.saturday,
									sunday: person.sunday,
									registerTime: false,
								},
								roles: data.roles,
								teams: data.teams,
								teamPersons: data.teamPersons,
								removeLowHigh: data.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high'),
							});
					  },
		};

		return !isUsingProjectAllocation && shouldSeeHeatmap
			? new TimelineHeatmapPersonGroup(personGroupData)
			: new PersonGroup(personGroupData);
	}

	getPhaseCompletion(phaseId) {
		const phase = this.getData().phases.find(phase => phase.id === phaseId);
		const project = this.getData().projects.find(project => project.id === phase.projectId);
		const phaseTasks = this.getData().tasks.filter(task => task.phaseId === phaseId);

		let timeRegistered = 0;
		let timeRegisteredNotDone = 0;
		let remaining = 0;
		let forecast = 0;
		let doneForecast = 0;
		let doneTasksCount = 0;
		for (const task of phaseTasks) {
			timeRegistered += (this.getData().parentTimeRegistrationMap.get(task.id) || []).reduce(
				(total, timeRegistration) => total + timeRegistration.minutesRegistered,
				0
			);
			forecast += task.estimateForecast;
			if (task.done) {
				doneForecast += task.estimateForecast;
			} else {
				timeRegisteredNotDone += (this.getData().parentTimeRegistrationMap.get(task.id) || []).reduce(
					(total, timeRegistration) => total + timeRegistration.minutesRegistered,
					0
				);
			}
			remaining += task.done ? 0 : task.timeLeft;
			if (task.done) {
				++doneTasksCount;
			}
		}

		let completion;
		if (this.getData().viewer.availableFeatureFlags.find(flag => flag.key === 'use_new_progress_calc')) {
			completion =
				Util.calculateTaskGroupCompletion(
					doneForecast,
					timeRegisteredNotDone,
					remaining,
					doneTasksCount,
					phaseTasks.length
				) * 100;
		} else {
			completion = Util.deprecated_calculateElementProgress(
				forecast,
				timeRegistered,
				remaining,
				phaseTasks.length,
				doneTasksCount,
				project.estimationUnit === ESTIMATION_UNIT.HOURS,
				project.minutesPerEstimationPoint,
				false,
				false
			);
		}
		return completion;
	}

	onClick(e) {
		if ((!e.target || e.target.id !== 'actions-btn') && this.state.showExpandedActionMenu) {
			this.hideExpandedActionMenu();
		}
		if (this.state.contextMenuX) {
			this.setState({contextMenuX: undefined, contextMenuY: undefined, contextMenuOptions: undefined});
		}
	}

	onKeyDown(e) {
		if (e.key === 'Shift' && !this.isShiftDown) {
			this.isShiftDown = true;
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		}
		//Disable shortcuts in simulation mode
		if (e.altKey && e.shiftKey && this.state.simulationMode) {
			e.stopPropagation();
		}
	}

	onKeyUp(e) {
		if (e.key === 'Shift' && this.isShiftDown) {
			this.isShiftDown = false;
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		}
	}

	showExpandedActionMenu() {
		this.setState({
			expandedActionMenuY: this.state.collapsedActionMenuY,
			expandedActionMenuData: this.state.collapsedActionMenuData,
			showExpandedActionMenu: true,
		});
	}

	hideExpandedActionMenu() {
		this.setState({
			showExpandedActionMenu: false,
		});
	}

	onTimelineVerticalScroll(delta) {
		if (this.state.showExpandedActionMenu) {
			this.setState({showExpandedActionMenu: false});
		}
		if (this.state.contextMenuOptions) {
			this.setState({contextMenuX: null, contextMenuY: null, contextMenuOptions: null});
		}
	}

	onTimelineHorizontalScroll(delta) {
		if (this.state.showExpandedActionMenu) {
			this.setState({showExpandedActionMenu: false});
		}
		if (this.state.contextMenuOptions) {
			this.setState({contextMenuX: null, contextMenuY: null, contextMenuOptions: null});
		}
	}

	onProjectGroupMouseEnter(data, groupData) {
		if (this.props.isProjectTimeline) return; //Don't want to show the 3 dot menu in project timeline
		this.setState({
			showCollapsedActionMenu: true,
			collapsedActionMenuY: groupData.y + 6,
			collapsedActionMenuData: data,
		});
	}

	onProjectGroupMouseLeave() {
		if (!this.state.showCollapsedActionMenu) return;
		this.setState({showCollapsedActionMenu: false});
	}

	isTaskStarted(taskStatusColumnId) {
		//Status column will not be there if a project that contains tasks is duplicated
		//Since all tasks are put in the todo column on duplication, this should not be a problem
		const statusColumn = this.getData().statusColumns.find(statusColumn => statusColumn.id === taskStatusColumnId);
		return statusColumn && statusColumn.category !== WorkflowCategories.TODO;
	}

	onDistributionItemMouseEnter(itemType, parentId, childId, itemData, e) {
		if (this.state.dataLoaded) {
			const decodedParentId = atob(parentId);
			const isProjectGroupItem = decodedParentId.startsWith('ProjectGroupType');
			const project = this.getData().projects.find(project => {
				return project.id === (isProjectGroupItem ? childId : parentId);
			});
			const clients = this.getData().clients;
			const projectGroup = this.getData().projectGroups.find(projectGroup => projectGroup.id === parentId);
			const phase =
				itemType === ITEM_TYPE.PROJECT_SCHEDULING_PHASE
					? this.getData().phases.find(phase => phase.id === childId)
					: undefined;
			if (projectGroup) {
				let forecast = 0;
				this.getData().projects.forEach(subProject => {
					if (subProject.projectGroupId === projectGroup.id) {
						forecast += subProject.forecast;
					}
				});
				projectGroup.forecast = forecast;
			}
			if (phase) {
				let forecast = 0;
				this.getData().tasks.forEach(task => {
					if (task.phaseId === phase.id) {
						forecast += task.estimateForecast;
					}
				});
				phase.forecast = forecast;
			}
			if (!project && !projectGroup) return; //This is a possibility when you delete a project that is currently under your mouse
			const allocationData = getAllocationData(this, itemType, parentId, childId);

			this.setState({
				hoverX: e.clientX,
				hoverY: e.clientY,
				showDistributionBox: false,
			});
			setTimeout(() => {
				this.setState({
					distributionBoxX: e.clientX,
					distributionBoxY: itemData.y,
					distributionBoxData: {
						project,
						clients,
						projectGroup,
						phase,
						allocationData,
					},
				});
				if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY) {
					this.setState({showDistributionBox: true, distributionBoxX: e.clientX});
				}
			}, 200);
		}
	}

	onDistributionItemMouseLeave() {
		this.setState({showDistributionBox: false, hoverX: null, hoverY: null, distributionBoxData: null});
	}

	onDistributionItemMouseMove(data, e) {
		if (this.state.dataLoaded) {
			this.setState({
				hoverX: e.clientX,
				hoverY: e.clientY,
				showDistributionBox: false,
			});
			setTimeout(() => {
				if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY && this.state.distributionBoxData) {
					this.setState({showDistributionBox: true, distributionBoxX: e.clientX});
				}
			}, 200);
		}
	}

	onDistributionItemClick(itemType, parentId, childId, item) {
		if (this.state.dataLoaded) {
			const {
				intl,
				intl: {formatMessage},
			} = this.props;
			const data = this.getData();
			const decodedParentId = atob(parentId);
			const isProjectGroupItem = decodedParentId.startsWith('ProjectGroupType') && !childId;
			const isPhaseItem = itemType === ITEM_TYPE.PROJECT_SCHEDULING_PHASE;
			const isProjectItem = !isProjectGroupItem && itemType === ITEM_TYPE.PROJECT_SCHEDULING_PROJECT;
			const project = data.projects.find(project => {
				return project.id === (decodedParentId.startsWith('ProjectGroupType') ? childId : parentId);
			});
			const projectGroup = isProjectGroupItem
				? data.projectGroups.find(projectGroup => projectGroup.id === parentId)
				: undefined;

			const allocationData = getAllocationData(this, itemType, parentId, childId);

			const roleDataMap = isPhaseItem
				? allocationData.phases.find(phaseData => phaseData.id === childId).roleDataMap
				: isProjectItem
				? project.isInProjectGroup
					? allocationData.projects.find(projectData => projectData.id === project.id).roleDataMap
					: allocationData.project.roleDataMap
				: allocationData.projectGroup.roleDataMap;

			const roleDataArray = [];
			for (const entry of roleDataMap.entries()) {
				if (!entry[1].allocated && !entry[1].remaining) continue;
				roleDataArray.push({
					name: entry[0]
						? data.roles.find(role => {
								return role.id === entry[0];
						  }).name
						: formatMessage({id: 'scheduling.project_scheduling.any_role'}),
					allocated: Util.convertMinutesToFullHour(entry[1].allocated, intl),
					remaining: Util.convertMinutesToFullHour(entry[1].allocated - entry[1].remaining, intl),
					difference: Util.convertMinutesToFullHour(entry[1].allocated - entry[1].remaining, intl),
					isDifferenceNegative: entry[1].allocated - entry[1].remaining < 0,
				});
			}

			const phase = isPhaseItem ? this.getData().phases.find(phase => phase.id === childId) : null;

			showModal({
				type: MODAL_TYPE.PROJECT_MILESTONE_CAPACITY,
				roleData: roleDataArray,
				statusColor:
					isPhaseItem || isProjectItem
						? data.projectStatuses.find(projectStatus => projectStatus.projectId === project.id).color
						: undefined,
				mainLabel: isProjectItem ? project.name : isPhaseItem ? phase.name : projectGroup.name,
				subLabel: isProjectItem
					? project.clientId
						? data.clients.find(client => client.id === project.clientId).name
						: ''
					: '',
				projectColor: isProjectItem || isPhaseItem ? project.projectColor : projectGroup.color,
				startDate: getMomentFromCanvasTimelineDate(item.startDate),
				endDate: getMomentFromCanvasTimelineDate(item.endDate),
				projectId: isProjectGroupItem ? projectGroup.companyProjectGroupId : project.companyProjectId,
				isProjectGroup: isProjectGroupItem,
				isPhase: isPhaseItem,
			});

			this.setState({
				clickedItem: null,
				showLoader: false,
			});
		} else {
			this.setState({
				showLoader: true,
				clickedItem: {
					itemType,
					parentId,
					childId,
					item,
				},
			});
		}
	}

	onPhasesGroupMouseEnter(hoveredPhaseGroupIds, groupData) {
		const doAnyPhasesWithDatesExist =
			hoveredPhaseGroupIds &&
			this.getData().phases.filter(
				phase => hoveredPhaseGroupIds.includes(phase.id) && phase.deadlineDay && phase.startDay
			).length;
		if (!doAnyPhasesWithDatesExist) return; //Don't show hover effect when there is nothing to scroll to
		this.setState({showArrowClickableArea: true, arrowClickableAreaY: groupData.y + 6, hoveredPhaseGroupIds});
	}

	onPhasesGroupMouseLeave() {
		this.setState({showArrowClickableArea: false});
	}

	onPhasesGroupArrowClick(isPrevious) {
		const {hoveredPhaseGroupIds} = this.state;
		if (!hoveredPhaseGroupIds || !hoveredPhaseGroupIds.length) return;
		const timeline = this.timeline;
		const screenCenterDate = timeline.startDate + timeline.state.canvasWidth / timeline.pixelsPerDay / 2;
		//Make minimum scroll distance 3 days because it makes little sense to fire the animation just to scroll by a few pixels
		const phaseItems = this.state.items.filter(
			item =>
				item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_PHASE &&
				hoveredPhaseGroupIds.includes(item.groupId) &&
				(isPrevious ? item.startDate - screenCenterDate < -2 : item.startDate - screenCenterDate > 2)
		);
		if (!phaseItems.length) return; //Already scrolled to furthermost phase
		//Sort by startDate descending, we want to scroll to the item that is the closest to the center in the scrolling direction
		phaseItems.sort((a, b) => {
			if (a.startDate < b.startDate) return isPrevious ? 1 : -1;
			if (b.startDate < a.startDate) return isPrevious ? -1 : 1;
			return 0;
		});
		timeline.scrollToCanvasDate(phaseItems[0].startDate);
		tracking.trackEvent('Scheduling left/right arrow navigation used');
	}

	sortPhaseGroupsByDate(phaseGroups) {
		for (const phaseGroup of phaseGroups) {
			phaseGroup.groups.sort((a, b) => {
				// order tasks within milestones
				if (a.groupType !== GROUP_TYPE.PROJECT_SCHEDULING_TASK || b.groupType !== GROUP_TYPE.PROJECT_SCHEDULING_TASK)
					return 0;
				const aTask = a.data.task;
				const bTask = b.data.task;
				const aEndDate = createCanvasTimelineDate(aTask.deadlineYear, aTask.deadlineMonth, aTask.deadlineDay);
				const bEndDate = createCanvasTimelineDate(bTask.deadlineYear, bTask.deadlineMonth, bTask.deadlineDay);
				const aStartDate = createCanvasTimelineDate(aTask.startYear, aTask.startMonth, aTask.startDay);
				const bStartDate = createCanvasTimelineDate(bTask.startYear, bTask.startMonth, bTask.startDay);
				const aHasDates = aStartDate && aEndDate && areItemDatesValid(aStartDate, aEndDate);
				const bHasDates = bStartDate && bEndDate && areItemDatesValid(bStartDate, bEndDate);
				if (!aHasDates || !bHasDates) return aHasDates ? 1 : bHasDates ? -1 : 0;
				if (aStartDate > bStartDate) return 1;
				if (aStartDate < bStartDate) return -1;
				if (aEndDate > bEndDate) return 1;
				if (aEndDate < bEndDate) return -1;
				return 0;
			});
		}

		// order milestones
		phaseGroups = Util.sortMilestones(phaseGroups, true);
	}

	composeTaskAllocation(personId, parent, group, stepDataArray, startDate, pixelsPerDay, step, hideWeekends = false) {
		const parentId = parent.projectGroupId || parent.id;
		const dataArray = [];
		const decodedParentId = atob(parentId);
		const isProjectGroup = decodedParentId.startsWith('ProjectGroupType');
		const {formatMessage} = this.props.intl;

		const data = this.getData();
		const projectIds = isProjectGroup
			? data.projects.filter(project => project.projectGroupId === parentId).map(project => project.id)
			: [parentId];
		const project = data.projects.find(project => project.id === projectIds[0]);
		if (!project) return dataArray;
		const isHourEstimated = project.estimationUnit === ESTIMATION_UNIT.HOURS;

		const tasks = data.tasks.filter(
			task =>
				projectIds.includes(task.projectId) &&
				(this.state.simulationMode
					? task.autoSchedulingPerson && task.autoSchedulingPerson.id === personId
					: task.assignedPersons.includes(personId))
		);
		const taskIds = tasks.map(task => task.id);
		const timeRegistrations = data.timeRegistrations.filter(timeRegistration => {
			return (
				timeRegistration.personId === personId &&
				(projectIds.includes(timeRegistration.projectId) || taskIds.includes(timeRegistration.taskId))
			);
		});
		const dates = [];

		let totalEstimates = 0;
		for (const task of tasks) {
			if (!task.startYear || !task.deadlineYear) continue;
			const taskStartDate = createCanvasTimelineDate(task.startYear, task.startMonth, task.startDay);
			const taskEndDate = createCanvasTimelineDate(task.deadlineYear, task.deadlineMonth, task.deadlineDay);
			if (!areItemDatesValid(taskStartDate, taskEndDate)) continue;
			dates.push({startDate: taskStartDate, endDate: taskEndDate, isFilled: true});
			totalEstimates += task.estimateForecast / (isHourEstimated ? 60.0 : 1.0);
		}
		for (const timeRegistration of timeRegistrations) {
			const date = createCanvasTimelineDate(timeRegistration.year, timeRegistration.month, timeRegistration.day);
			if (!areItemDatesValid(date, date)) continue;
			dates.push({startDate: date, endDate: date, isFilled: true});
		}

		let itemStartDate, itemEndDate, width, weekendDaysBefore, weekendDaysUntilTimeline, weekendDaysWithin;
		if (dates.length !== 0) {
			const orderedByStartDates = dates.slice().sort((a, b) => a.startDate - b.startDate);
			itemStartDate = orderedByStartDates[0].startDate;
			const orderedByEndDates = dates.slice().sort((a, b) => b.endDate - a.endDate);
			itemEndDate = orderedByEndDates[0].endDate;
			if (hideWeekends) {
				weekendDaysBefore =
					getWeekdaysBetweenDates(Math.floor(startDate), itemStartDate, null, false, true)[5] +
					getWeekdaysBetweenDates(Math.floor(startDate), itemStartDate, null, false, true)[6];
				weekendDaysUntilTimeline =
					getWeekdaysBetweenDates(itemStartDate, Math.floor(startDate), null, false, true)[5] +
					getWeekdaysBetweenDates(itemStartDate, Math.floor(startDate), null, false, true)[6];
				weekendDaysWithin =
					getWeekdaysBetweenDates(itemStartDate, itemEndDate, null, false, false)[5] +
					getWeekdaysBetweenDates(itemStartDate, itemEndDate, null, false, false)[6];
			}
			width = hideWeekends
				? (itemEndDate - weekendDaysWithin - itemStartDate + 1) * pixelsPerDay - 1
				: pixelsPerDay * (itemEndDate + 1 - itemStartDate);
		}
		const splitStartDate = getMomentFromCanvasTimelineDate(itemStartDate);
		const splitEndDate = getMomentFromCanvasTimelineDate(itemEndDate);

		const item = new TaskAllocationItem({
			y: group.screenY,
			totalEstimates,
			x: hideWeekends
				? (itemStartDate - startDate - weekendDaysBefore + weekendDaysUntilTimeline) * pixelsPerDay
				: (itemStartDate - startDate) * pixelsPerDay,
			width,
			color: group.data.color,
			dates,
			pixelsPerDay,
			isHourEstimated,
			intl: this.props.intl,
			onMouseEnter: this.onAllocationMouseEnter.bind(
				this,
				{
					name: parent.name,
					startDay: splitStartDate.date(),
					startMonth: splitStartDate.month() + 1,
					startYear: splitStartDate.year(),
					endDay: splitEndDate.date(),
					endMonth: splitEndDate.month() + 1,
					endYear: splitEndDate.year(),
					parent,
				},
				parentId,
				isHourEstimated
					? Util.convertMinutesToFullHour(totalEstimates * 60, this.props.intl)
					: formatMessage({id: 'common.x_points'}, {points: totalEstimates})
			),
			onMouseLeave: this.onAllocationMouseLeave.bind(this),
			onMouseMove: this.onAllocationMouseMove.bind(this),
			hideWeekends,
		});
		dataArray.push(item);
		return dataArray;
	}

	viewProject(isGroup, id) {
		const link = isGroup ? projectGroupUrl(id) : projectUrl(id);
		const lastViewedPage =
			(isGroup
				? localStorage.getItem('project-group-section-last-viewed')
				: localStorage.getItem('project-section-last-viewed')) || 'workflow';
		//open project/project group page in new tab
		window.open(`${link}/${lastViewedPage}`, '_blank');
	}

	setProjectStatus(projectId, newStatus) {
		const onSuccess = result => {
			if (result && result.updateProject && result.updateProject.project) {
				const {groups, items} = this.state;
				const itemToUpdate = items.find(
					item =>
						item.groupId === projectId &&
						item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_PROJECT &&
						item.data.project &&
						item.data.project.id === projectId
				);
				const stateObject = {};
				if (itemToUpdate) {
					const itemIndex = items.indexOf(itemToUpdate);
					itemToUpdate.data.isPlanning =
						result.updateProject.project.status === PROJECT_STATUS.PLANNING ||
						result.updateProject.project.status === PROJECT_STATUS.OPPORTUNITY;
					items[itemIndex] = itemToUpdate;
					stateObject.items = items;
				}
				const groupToUpdate = groups.find(group => group.id === projectId);
				const groupIndex = groups.indexOf(groupToUpdate);
				if (groupToUpdate) {
					groupToUpdate.data.status = result.updateProject.project.status;
					groupToUpdate.onMouseEnter = this.onProjectGroupMouseEnter.bind(this, result.updateProject.project);
					groups[groupIndex] = groupToUpdate;
					stateObject.groups = groups;
				}
				if (stateObject.groups !== undefined || stateObject.items !== undefined) {
					this.setState(stateObject);
				}
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
			}
		};
		updateProject(
			{
				id: projectId,
				status: newStatus,
			},
			onSuccess
		);
		this.setState({
			showExpandedActionMenu: false,
		});
	}

	duplicateProject(projectId) {
		showModal({
			type: MODAL_TYPE.NEW_PROJECT_V2,
			projectToDuplicateId: projectId,
		});
		this.setState({
			showExpandedActionMenu: false,
		});
	}

	deleteProject(projectId) {
		const {formatMessage} = this.props.intl;
		showModal({
			type: MODAL_TYPE.CONFIRM_PROJECT_DELETION,
			confirmText: formatMessage({id: 'settings.confirm'}),
			onDelete: () => {
				const project = this.getData().projects.find(project => project.id === projectId);

				const isInProjectGroup = !!project.projectGroupId;

				// Clear the heatmap cache
				for (const projectPerson of this.getData().projectPersons.filter(
					projectPerson => projectPerson.projectId === project.id
				)) {
					this.props.heatmapCache.delete(projectPerson.personId);
				}

				this.getData().projectPersons = this.getData().projectPersons.filter(
					projectPerson => projectPerson.projectId !== project.id
				);
				this.getData().allocations = this.getData().allocations.filter(
					allocation => allocation.projectId !== project.id
				);
				this.getData().timeRegistrations = this.getData().timeRegistrations.filter(
					timeRegistration =>
						timeRegistration.taskId || timeRegistration.idleTimeId || timeRegistration.projectId !== project.id
				);
				this.getData().tasks = this.getData().tasks.filter(task => task.projectId !== project.id);

				this.setState({showLoadingOverlay: true});
				const onSuccess = result => {
					if (
						result.deleteProject &&
						result.deleteProject.errors &&
						result.deleteProject.errors.length === 1 &&
						result.deleteProject.errors[0] === 'TIME_REGISTRATION_IN_LOCKED_PERIOD'
					) {
						showModal({
							type: MODAL_TYPE.WARNING_DATE_LOCKED,
							nonTimeRegWarning: true,
						});
					} else {
						if (isInProjectGroup) {
							const projectGroup = this.state.groups.find(group => group.id === project.projectGroupId);
							if (projectGroup) {
								let groupIndex = projectGroup.groups.findIndex(group => group.id === project.id);
								if (groupIndex >= 0) {
									projectGroup.groups.splice(groupIndex, 1);
								}
								if (projectGroup.groups.length <= 1) {
									groupIndex = this.state.groups.indexOf(projectGroup);
									if (groupIndex >= 0) {
										this.state.groups.splice(groupIndex, 1);
									}
								}
							}
						} else {
							const groupIndex = this.state.groups.findIndex(group => group.id === project.id);
							if (groupIndex >= 0) {
								this.state.groups.splice(groupIndex, 1);
							}
						}

						const index = this.getData().projects.indexOf(project);
						if (index >= 0) {
							this.getData().projects.splice(index, 1);
						}
						if (project.projectGroupId) {
							const projectGroupProjects = this.getData().projects.filter(
								p => p.projectGroupId === project.projectGroupId
							);
							if (projectGroupProjects.length === 0) {
								const projectGroupIndex = this.getData().projectGroups.findIndex(
									projectGroup => projectGroup.id === project.projectGroupId
								);
								if (projectGroupIndex >= 0) {
									this.getData().projectGroups.splice(projectGroupIndex, 1);
								}
							}
						}
						dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
					}
					this.setState({showLoadingOverlay: false});
				};
				Util.CommitSchedulingModalUpdate(
					DeleteProjectMutation,
					{
						id: projectId,
						projectGroupId: project.projectGroupId,
					},
					onSuccess
				);
			},
		});

		this.setState({
			showExpandedActionMenu: false,
		});
	}

	onTaskItemMouseEnter(task, data, e) {
		const {parentTaskToSubtaskMap} = this.state.data;
		if (isTaskInHierarchy(task, parentTaskToSubtaskMap)) {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}

		const relevantDependencyTaskIdSet = getRelevantDependencyTaskIdSet(this);
		if (relevantDependencyTaskIdSet && relevantDependencyTaskIdSet.has(task.id)) {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}

		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			this.setState({
				detailBoxLeft: data.x,
				detailBoxY: data.y,
				detailBoxTop: data.y - 2,
				detailBoxData: {task, allocation: null},
			});
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);
	}

	onTaskItemMouseMove(data, e) {
		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY && this.state.detailBoxData) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);

		// Check if the task has a person assigned
		if (data.item && data.item.data.task && data.item.data.task.autoSchedulingPerson) {
			const isOverAllocated = data.item.data.task.isOverAllocated;
			// Check if the user is hovering over the assigned picture
			const itemEnd = data.x + data.width + Math.min(data.item.x, 0);
			if (e.clientX >= itemEnd && e.clientX <= itemEnd + AUTO_SCHEDULING_PERSON_WIDTH) {
				this.pictureEndX = itemEnd + AUTO_SCHEDULING_PERSON_WIDTH;
				this.pictureStartY = data.y;
				this.pictureEndY = data.y + data.height;

				this.getData().tasks.forEach(task => {
					task.showImageHover = false;
				});

				data.item.data.task.showImageHover = true;
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
				this.setState({assignedPersonHoverData: {data, overAllocated: false}});
				// Check if the useris hovering over the overallocation warning icon
			} else if (isOverAllocated && e.clientX >= data.x + data.width + AUTO_SCHEDULING_PERSON_WIDTH - 4) {
				data.item.data.task.showImageHover = false;
				if (
					!this.state.assignedPersonHoverData ||
					(this.state.assignedPersonHoverData && !this.state.assignedPersonHoverData.overAllocated)
				) {
					dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
					this.setState({assignedPersonHoverData: {data, overAllocated: true}});
				}
			} else {
				data.item.data.task.showImageHover = false;
				if (this.state.assignedPersonHoverData) {
					this.getData().tasks.forEach(task => {
						task.showImageHover = false;
					});
					dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
					this.setState({assignedPersonHoverData: null});
				}
			}
		}
	}

	onTaskItemMouseLeave(task) {
		const {parentTaskToSubtaskMap} = this.state.data;
		if (isTaskInHierarchy(task, parentTaskToSubtaskMap)) {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}

		const relevantDependencyTaskIdSet = getRelevantDependencyTaskIdSet(this);
		if (relevantDependencyTaskIdSet && relevantDependencyTaskIdSet.has(task.id)) {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}

		this.setState({showDetailBox: false, hoverX: null, hoverY: null, detailBoxData: null});
	}

	onAllocationMouseEnter(allocation, parentId, totalEstimates, positionData, e) {
		if (!allocation && !parentId) {
			return false;
		}

		if (!allocation && parentId) {
			const decodedParentId = atob(parentId);
			const isProjectGroup = decodedParentId.startsWith('ProjectGroupType');
			allocation = {
				projectId: isProjectGroup ? undefined : parentId,
				projectGroupId: isProjectGroup ? parentId : undefined,
			};
		}

		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			this.setState({
				detailBoxLeft: positionData.x,
				detailBoxX: e.clientX,
				detailBoxY: positionData.y,
				detailBoxTop: positionData.y - 2,
				detailBoxData: {task: null, allocation, totalEstimates},
			});
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);
	}

	onAllocationMouseLeave() {
		this.setState({showDetailBox: false, hoverX: null, hoverY: null, detailBoxData: null});
	}

	onAllocationMouseMove(data, e) {
		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY && this.state.detailBoxData) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);
	}

	onDoneOrHaltedMoveAttempt(taskItem) {
		const {formatMessage} = this.props.intl;
		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div>
					<Warning messageId="scheduling.done_warning" useInfoIcon={true} />
					<div className="warning-part-2">{formatMessage({id: 'scheduling.done_warning_2'})}</div>
				</div>
			),
			className: 'default-warning-modal',
			buttons: [
				{
					text: formatMessage({id: 'common.filter-close'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
			],
		});
	}

	onTaskItemMoving(taskItem, group, startDateDelta, endDateDelta, dragData) {
		const {isDraggingWholeDependencyChainModeOn, data} = this.state;
		const {parentTaskToSubtaskMap} = data;

		// Find ids of sub tasks to move with task.
		const subTasksToMoveIds = getSubTasks(parentTaskToSubtaskMap, data.tasks, taskItem.data.task, true).map(
			item => item.id
		);
		const dependencyChainTaskIdSet = new Set();
		const isDependencyMove = isDraggingWholeDependencyChainModeOn || this.isShiftDown;
		const isDragPointCenter = dragData.dragPoint === ITEM_DRAG_POINT.CENTER;
		if (isDependencyMove) {
			if (isDragPointCenter) {
				const taskDependency = this.state.dependencies.find(
					dependency =>
						dependency.thisDependsOnTaskId === taskItem.data.task.id ||
						dependency.taskIdDependsOnThis === taskItem.data.task.id
				);
				if (taskDependency) {
					this.taskItemMoveTotalDayDifference = this.taskItemMoveTotalDayDifference
						? (this.taskItemMoveTotalDayDifference += startDateDelta)
						: startDateDelta;
					dependencyChainTaskIdSet.add(taskDependency.thisDependsOnTaskId);
					dependencyChainTaskIdSet.add(taskDependency.taskIdDependsOnThis);
					let previousTaskIdCount = 0;
					let currentTaskIdCount = 2;
					while (previousTaskIdCount !== currentTaskIdCount) {
						for (const dependency of this.state.dependencies.filter(
							dependency =>
								dependencyChainTaskIdSet.has(dependency.thisDependsOnTaskId) ||
								dependencyChainTaskIdSet.has(dependency.taskIdDependsOnThis)
						)) {
							dependencyChainTaskIdSet.add(dependency.thisDependsOnTaskId);
							dependencyChainTaskIdSet.add(dependency.taskIdDependsOnThis);
						}
						previousTaskIdCount = currentTaskIdCount;
						currentTaskIdCount = dependencyChainTaskIdSet.size;
					}
					const itemsToMove = this.state.items.filter(
						item =>
							item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK &&
							!item.data.task.done &&
							dependencyChainTaskIdSet.has(item.data.task.id) &&
							!subTasksToMoveIds.includes(item.data.task.id)
					);
					for (const item of itemsToMove) {
						//Do not move dragged task since it is going to be already moved due to default behavior
						if (item !== taskItem) {
							item.shift(startDateDelta);
						}
						// Clear the cache for affected users
						this.deleteTimelineHeatmapCacheForTaskAssignees(item.data.task);
						this.updateTaskDataDates(item.data.task, item.startDate, item.endDate);
					}
				}
			}
		} else {
			// Clear the cache for affected users
			this.deleteTimelineHeatmapCacheForTaskAssignees(taskItem.data.task);
		}

		// Moving sub tasks
		// Only move task once, either its moved by a dependency or as a sub task, not both
		const subTaskItemsToMove = this.state.items.filter(item => {
			return ITEM_TYPE.PROJECT_SCHEDULING_TASK === item.itemType && subTasksToMoveIds.includes(item.data.task.id);
		});
		for (const itemToMove of subTaskItemsToMove) {
			itemToMove.startDate += startDateDelta;
			itemToMove.endDate += endDateDelta;

			// Clear the cache for affected users
			this.deleteTimelineHeatmapCacheForTaskAssignees(itemToMove.data.task);
			this.updateTaskDataDates(itemToMove.data.task, itemToMove.startDate, itemToMove.endDate);
		}

		return !isDependencyMove || !isDragPointCenter;
	}

	deleteTimelineHeatmapCacheForTaskAssignees(task) {
		if (this.props.isProjectTimeline && task.assignedPersons) {
			if (isSimulationMode()) {
				if (task.autoSchedulingPerson) {
					this.timelineHeatmapCache.delete(task.autoSchedulingPerson.id);
				}
			} else {
				task.assignedPersons.forEach(personId => {
					this.timelineHeatmapCache.delete(personId);
				});
			}
		}
	}

	updateSimulationChangeMap(type, item) {
		const id = type === 'allocations' ? item.data.allocation.id : item.groupId;

		if (this.state.simulationMode) {
			const {simulationChangeMap} = this.state;
			let simulationChangeItem = simulationChangeMap.get(type).get(id);
			if (!simulationChangeItem) {
				simulationChangeItem = {};
			}
			simulationChangeItem.initialStartDate = item.data.startDate;
			simulationChangeItem.initialEndDate = item.data.endDate;
			simulationChangeItem.startDate = item.startDate;
			simulationChangeItem.endDate = item.endDate;
			simulationChangeMap.get(type).set(id, simulationChangeItem);

			this.setState({simulationChangeMap});

			return false;
		}
	}

	onTaskItemMoveEnd(item) {
		if (this.taskItemMoveTotalDayDifference) {
			const {parentTaskToSubtaskMap} = this.state.data;
			// Find ids of sub tasks since they should not be moved by dependency moving
			const subTasksToMoveIds = getSubTasks(parentTaskToSubtaskMap, this.state.data.tasks, item.data.task, true).map(
				item => item.id
			);

			const dependencyChainTaskIdSet = new Set();
			dependencyChainTaskIdSet.add(item.groupId);
			let previousTaskIdCount = 0;
			let currentTaskIdCount = 1;
			while (previousTaskIdCount !== currentTaskIdCount) {
				for (const dependency of this.state.dependencies.filter(
					dependency =>
						(dependencyChainTaskIdSet.has(dependency.thisDependsOnTaskId) ||
							dependencyChainTaskIdSet.has(dependency.taskIdDependsOnThis)) &&
						!subTasksToMoveIds.includes(dependency.thisDependsOnTaskId) &&
						!subTasksToMoveIds.includes(dependency.taskIdDependsOnThis)
				)) {
					dependencyChainTaskIdSet.add(dependency.thisDependsOnTaskId);
					dependencyChainTaskIdSet.add(dependency.taskIdDependsOnThis);
				}
				previousTaskIdCount = currentTaskIdCount;
				currentTaskIdCount = dependencyChainTaskIdSet.size;
			}
			shiftDependencyChain({ids: dependencyChainTaskIdSet, dayDelta: this.taskItemMoveTotalDayDifference});
			this.taskItemMoveTotalDayDifference = undefined;
			// TODO: Prevent this too in simulation mode?
		} else {
			// Prevent default behaviour if we are in simulation mode
			const startDate = getMomentFromCanvasTimelineDate(item.startDate);
			const endDate = getMomentFromCanvasTimelineDate(item.endDate);

			item.data.task.startYear = startDate.year();
			item.data.task.startMonth = startDate.month() + 1;
			item.data.task.startDay = startDate.date();
			item.data.task.deadlineYear = endDate.year();
			item.data.task.deadlineMonth = endDate.month() + 1;
			item.data.task.deadlineDay = endDate.date();
			item.data.task.startFrom = null;
			this.runPersonUtilizationWebWorker();

			this.updateSimulationChangeMap('tasks', item);

			if (!this.state.simulationMode) {
				updateTask({
					ids: [item.groupId],
					startYear: startDate.year(),
					startMonth: startDate.month() + 1,
					startDay: startDate.date(),
					deadlineYear: endDate.year(),
					deadlineMonth: endDate.month() + 1,
					deadlineDay: endDate.date(),
				});
			}
		}
	}

	onAllocationItemMoving(item, d1, d2, d3, dragData) {
		const startDate = getMomentFromCanvasTimelineDate(dragData.newStartDate || item.startDate);
		const endDate = getMomentFromCanvasTimelineDate(dragData.newEndDate || item.endDate);
		item.data.allocation.startYear = startDate.year();
		item.data.allocation.startMonth = startDate.month() + 1;
		item.data.allocation.startDay = startDate.date();
		item.data.allocation.endYear = endDate.year();
		item.data.allocation.endMonth = endDate.month() + 1;
		item.data.allocation.endDay = endDate.date();
		item.data.totalHours = getAllocationTotal(item.data.allocation) / 60;
		return true;
	}

	onAllocationItemMoveEnd(item) {
		const startDate = getMomentFromCanvasTimelineDate(item.startDate);
		const endDate = getMomentFromCanvasTimelineDate(item.endDate);

		item.data.allocation.startYear = startDate.year();
		item.data.allocation.startMonth = startDate.month() + 1;
		item.data.allocation.startDay = startDate.date();
		item.data.allocation.endYear = endDate.year();
		item.data.allocation.endMonth = endDate.month() + 1;
		item.data.allocation.endDay = endDate.date();

		this.runPersonUtilizationWebWorker();
		// Prevent default behaviour if we are in simulation mode
		this.updateSimulationChangeMap('allocations', item);

		if (!this.state.simulationMode) {
			updateAllocation({
				id: item.data.allocation.id,
				startYear: startDate.year(),
				startMonth: startDate.month() + 1,
				startDay: startDate.date(),
				endYear: endDate.year(),
				endMonth: endDate.month() + 1,
				endDay: endDate.date(),
			});
		}
	}

	onPhaseItemMoving(phaseItem, group, startDateDelta, endDateDelta, dragData) {
		if (dragData.dragPoint === ITEM_DRAG_POINT.CENTER) {
			//task will have null as phaseId and the groupId will not be null for no milestone group but that is OK since you can never drag no milestone item
			const itemsToMove = this.state.items.filter(item => {
				return [ITEM_TYPE.PROJECT_SCHEDULING_TASK].includes(item.itemType) && item.data.phaseId === phaseItem.groupId;
			});
			for (const itemToMove of itemsToMove) {
				itemToMove.startDate += startDateDelta;
				itemToMove.endDate += endDateDelta;
				this.updateTaskDataDates(itemToMove.data.task, itemToMove.startDate, itemToMove.endDate);
			}
		} else {
			for (const item of this.state.items) {
				if (item.itemType !== ITEM_TYPE.PROJECT_SCHEDULING_TASK) continue;
				if (item.data.phaseId !== phaseItem.groupId) continue;
				if (item.data.task.startFrom === 'PHASE') {
					item.startDate = phaseItem.startDate + startDateDelta;
					this.updateTaskDataDates(item.data.task, phaseItem.startDate + startDateDelta);
				}
				if (item.data.task.deadlineFrom === 'PHASE') {
					item.endDate = phaseItem.endDate + endDateDelta;
					this.updateTaskDataDates(item.data.task, null, phaseItem.endDate + endDateDelta);
				}
			}
		}
		return true;
	}

	onPhaseItemMoveEnd(item, group, initialGroup, dragData) {
		const {formatMessage} = this.props.intl;
		const commitMutation = () => {
			const startDate = getMomentFromCanvasTimelineDate(item.startDate);
			const endDate = getMomentFromCanvasTimelineDate(item.endDate);

			const phase = this.getData().phases.find(phase => phase.id === item.groupId);
			phase.startYear = startDate.year();
			phase.startMonth = startDate.month() + 1;
			phase.startDay = startDate.date();
			phase.deadlineYear = endDate.year();
			phase.deadlineMonth = endDate.month() + 1;
			phase.deadlineDay = endDate.date();

			this.runPersonUtilizationWebWorker();
			// Prevent default behaviour if we are in simulation mode
			this.updateSimulationChangeMap('phases', item);

			if (!this.state.simulationMode) {
				Util.CommitMutation(MovePhaseOnTimelineMutation, {
					id: item.groupId,
					deadlineDay: endDate.date(),
					deadlineMonth: endDate.month() + 1,
					deadlineYear: endDate.year(),
					startDay: startDate.date(),
					startMonth: startDate.month() + 1,
					startYear: startDate.year(),
					projectId: item.data.projectId,
				});
			}
		};

		const defaultCallback = () => {
			item.shift(-dragData.dayDifference);
			this.onPhaseItemMoving(item, group, -dragData.dayDifference, -dragData.dayDifference, dragData);
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		};

		if (dragData.dragPoint === ITEM_DRAG_POINT.CENTER && !this.state.simulationMode && this.hasTask(group)) {
			showModal({
				type: MODAL_TYPE.GENERIC,
				className: 'default-warning-modal',
				content: <Warning messageId="scheduling.warning_move_milestone" />,
				defaultCallback,
				buttons: [
					{
						text: formatMessage({id: 'common.cancel'}),
						callback: defaultCallback,
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.continue'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.GREEN,
						callback: commitMutation,
					},
				],
			});
		} else {
			commitMutation();
		}
	}

	hasTask(group) {
		return group.groups && group.groups.some(group => group.groupType === GROUP_TYPE.PROJECT_SCHEDULING_TASK);
	}

	updateTaskDataDates(task, canvasStartDate, canvasEndDate) {
		if (canvasStartDate) {
			const startDate = getMomentFromCanvasTimelineDate(canvasStartDate);
			task.startYear = startDate.year();
			task.startMonth = startDate.month() + 1;
			task.startDay = startDate.date();
		}
		if (canvasEndDate) {
			const endDate = getMomentFromCanvasTimelineDate(canvasEndDate);
			task.deadlineYear = endDate.year();
			task.deadlineMonth = endDate.month() + 1;
			task.deadlineDay = endDate.date();
		}
		// Clear timeline heatmap cache for affected persons
		this.deleteTimelineHeatmapCacheForTaskAssignees(task);
	}

	onProjectItemMoving(item, group, startDateDelta, endDateDelta, dragData) {
		if (item.data.projectGroupId) {
			const projectItemsInGroup = this.state.items.filter(
				stateItem => stateItem.data.projectGroupId === item.data.projectGroupId
			);
			let earliestStartDate = null;
			let latestEndDate = null;
			for (const projectItem of projectItemsInGroup) {
				if (earliestStartDate === null || projectItem.startDate < earliestStartDate) {
					earliestStartDate = projectItem.startDate;
				}
				if (latestEndDate === null || projectItem.endDate > latestEndDate) {
					latestEndDate = projectItem.endDate;
				}
			}
			const projectGroupItem = this.state.items.find(stateItem => stateItem.groupId === item.data.projectGroupId);
			projectGroupItem.startDate = earliestStartDate;
			projectGroupItem.endDate = latestEndDate;
		}

		if (dragData.dragPoint === ITEM_DRAG_POINT.CENTER) {
			const itemsToMove = this.state.items.filter(stateItem => {
				return (
					([
						ITEM_TYPE.PROJECT_SCHEDULING_PHASE,
						ITEM_TYPE.PROJECT_SCHEDULING_TASK,
						ITEM_TYPE.PROJECT_SCHEDULING_TEAM_ITEM,
					].includes(stateItem.itemType) &&
						stateItem.data.projectId === item.groupId) ||
					([ITEM_TYPE.PROJECT_SCHEDULING_PROJECT_ALLOCATION].includes(stateItem.itemType) &&
						stateItem.data.allocation.projectId === item.groupId)
				);
			});
			for (const itemToMove of itemsToMove) {
				itemToMove.resetItemRow();
				itemToMove.startDate += startDateDelta;
				itemToMove.endDate += endDateDelta;
				if (itemToMove.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK) {
					this.updateTaskDataDates(itemToMove.data.task, itemToMove.startDate, itemToMove.endDate);
				}
			}
		} else {
			for (const stateItem of this.state.items) {
				if (stateItem.itemType !== ITEM_TYPE.PROJECT_SCHEDULING_TASK) continue;
				if (stateItem.data.task.projectId !== item.groupId) continue;
				if (stateItem.data.task.startFrom === 'PROJECT') {
					stateItem.startDate = item.startDate + startDateDelta;
					this.updateTaskDataDates(stateItem.data.task, item.startDate + startDateDelta);
				}
				if (stateItem.data.task.deadlineFrom === 'PROJECT') {
					stateItem.endDate = item.endDate + endDateDelta;
					this.updateTaskDataDates(stateItem.data.task, null, item.endDate + endDateDelta);
				}
			}
		}
		return true;
	}

	onProjectItemMoveEnd(item, group, initialGroup, dragData) {
		if (this.state.dataFetched) {
			const {formatMessage} = this.props.intl;
			const commitMutation = () => {
				const startDate = getMomentFromCanvasTimelineDate(item.startDate);
				const endDate = getMomentFromCanvasTimelineDate(item.endDate);

				const project = this.getData().projects.find(project => project.id === item.groupId);
				project.projectStartYear = startDate.year();
				project.projectStartMonth = startDate.month() + 1;
				project.projectStartDay = startDate.date();
				project.projectEndYear = endDate.year();
				project.projectEndMonth = endDate.month() + 1;
				project.projectEndDay = endDate.date();

				for (const phaseGroup of group.groups[0].groups) {
					const phaseItem = this.state.items.find(item => item.groupId === phaseGroup.id);
					if (!phaseItem) continue;
					const phaseStartDate = getMomentFromCanvasTimelineDate(phaseItem.startDate);
					const phaseEndDate = getMomentFromCanvasTimelineDate(phaseItem.endDate);
					const phase = this.getData().phases.find(phase => phase.id === phaseItem.groupId);
					phase.startYear = phaseStartDate.year();
					phase.startMonth = phaseStartDate.month() + 1;
					phase.startDay = phaseStartDate.date();
					phase.deadlineYear = phaseEndDate.year();
					phase.deadlineMonth = phaseEndDate.month() + 1;
					phase.deadlineDay = phaseEndDate.date();
				}

				this.runPersonUtilizationWebWorker();
				// Prevent default behaviour if we are in simulation mode
				this.updateSimulationChangeMap('projects', item);

				if (!this.state.simulationMode) {
					Util.CommitMutation(MoveProjectOnTimelineMutation, {
						id: item.groupId,
						projectEndDay: endDate.date(),
						projectEndMonth: endDate.month() + 1,
						projectEndYear: endDate.year(),
						projectStartDay: startDate.date(),
						projectStartMonth: startDate.month() + 1,
						projectStartYear: startDate.year(),
					});
				}
			};

			const defaultCallback = () => {
				item.shift(-dragData.dayDifference);
				this.onProjectItemMoving(item, group, -dragData.dayDifference, -dragData.dayDifference, dragData);
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
			};

			if (dragData.dragPoint === ITEM_DRAG_POINT.CENTER && !this.state.simulationMode) {
				const project = this.getData().projects.find(project => project.id === item.groupId);
				showModal({
					type: MODAL_TYPE.GENERIC,
					className: 'default-warning-modal',
					content: (
						<Warning
							messageId={
								project.useManualAllocations
									? 'scheduling.warning_move_allocation_project'
									: 'scheduling.warning_move_project'
							}
						/>
					),
					defaultCallback,
					buttons: [
						{
							text: formatMessage({id: 'common.cancel'}),
							callback: defaultCallback,
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
						{
							text: formatMessage({id: 'common.continue'}),
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.GREEN,
							callback: commitMutation,
						},
					],
				});
			} else {
				commitMutation();
			}
			this.setState({
				movedItem: null,
				showLoader: false,
			});
		} else {
			this.setState({
				showLoader: true,
				movedItem: {
					item,
					group,
					initialGroup,
					dragData,
				},
			});
		}
	}

	toggleDependencyDragMode() {
		Util.localStorageSetItem('isDraggingWholeDependencyChainModeOn', !this.state.isDraggingWholeDependencyChainModeOn);
		this.setState({isDraggingWholeDependencyChainModeOn: !this.state.isDraggingWholeDependencyChainModeOn});
	}

	onPersonImageLoad() {
		if (this.personImageLoadTimeout) {
			clearTimeout(this.personImageLoadTimeout);
			this.personImageLoadTimeout = null;
		}
		this.personImageLoadTimeout = setTimeout(() => {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
		}, 500);
	}

	onForegroundContextMenu(e, mouseTargetData, canvasDate) {
		e.preventDefault();
		if (!mouseTargetData.itemData) return;
		const {item} = mouseTargetData.itemData;
		if (!item) return;

		// hide the tooltip
		this.setState({showDetailBox: false, hoverX: null, hoverY: null});

		if (item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_TASK) {
			onTaskContextMenu(this, e, item, true);
		} else if (item.itemType === ITEM_TYPE.PROJECT_SCHEDULING_PROJECT_ALLOCATION) {
			onAllocationContextMenu(this, e, item, canvasDate, true);
		}
	}

	onMouseMove(e) {
		let {autoSchedulingDragPersonId, autoSchedulingDragTranslateX, autoSchedulingDragTranslateY, offsetX, offsetY} =
			this.state;
		// Has to be changed if we change the height if the header
		const canvasOffsetTop = 78;
		const clientY = e.clientY - DATE_STEPS_SECTION_HEIGHT - canvasOffsetTop;
		// Check if there is an overallocation icon active, in that case we extend the end of the picture to account for the icon width
		let pictureEndX =
			this.state.assignedPersonHoverData && this.state.assignedPersonHoverData.overAllocated
				? this.pictureEndX + 20
				: this.pictureEndX;
		// Check if the mouse is past the picture on the X axis
		// Check if the mouse is past or before the picture on Y axis
		// In these cases, we want the name box gone
		if (e.clientX >= pictureEndX || clientY > this.pictureEndY || clientY < this.pictureStartY) {
			if (this.state.assignedPersonHoverData) {
				// Remove the hover effect
				const task = this.state.assignedPersonHoverData.data.item.data.task;
				if (task.showImageHover) {
					task.showImageHover = false;
					dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true});
				}
				this.setState({assignedPersonHoverData: null});
				this.pictureEndX = null;
				this.pictureStartY = null;
				this.pictureEndY = null;
			}
		}
		if (!autoSchedulingDragPersonId) return;
		if (this.autoSchedulingDragPersonFrame) {
			cancelAnimationFrame(this.autoSchedulingDragPersonFrame);
		}

		autoSchedulingDragTranslateX = e.clientX - 17 - (offsetX / 50) * (50 - this.mouseMoveCount);
		autoSchedulingDragTranslateY = e.clientY - 17 - (offsetY / 50) * (50 - this.mouseMoveCount);

		this.autoSchedulingDragPersonFrame = requestAnimationFrame(() => {
			if (this.mouseMoveCount < 50) {
				this.mouseMoveCount++;
			}

			this.setState({autoSchedulingDragTranslateX, autoSchedulingDragTranslateY}, () => {
				this.autoSchedulingDragPersonFrame = null;
			});
		});
	}

	resetRecalculateSteps() {
		this.setState({recalculateSteps: false});
	}

	setPreventFiltering(preventFiltering) {
		this.setState({preventFiltering});
	}

	render() {
		const {dayData, isProjectTimeline, sharedContext, projectId, groupId, shareUrl} = this.props;
		if (this.state.isShowingAutoScheduleOnLoad) {
			this.setState({
				isShowingAutoScheduleOnLoad: false,
			});
			this.showAutoSchedulingModal();
		}
		let loading = true;
		if (this.state.initData) {
			if (this.state.lightweightDataLoaded || this.state.dataLoaded) {
				loading = false;
			}
		}
		if (loading === true) {
			return (
				<div key={'c1'} className="canvas-scheduling">
					<div className="is-loading" />
				</div>
			);
		}

		const {formatMessage} = this.props.intl;
		const {
			data,
			lightWeightData,
			groups,
			items,
			showCollapsedActionMenu,
			collapsedActionMenuY,
			showExpandedActionMenu,
			expandedActionMenuY,
			expandedActionMenuData,
			showArrowClickableArea,
			arrowClickableAreaY,
			showDistributionBox,
			distributionBoxX,
			distributionBoxY,
			distributionBoxData,
			contextMenuX,
			contextMenuY,
			contextMenuOptions,
			showDetailBox,
			detailBoxX,
			detailBoxY,
			detailBoxData,
			autoScheduleProposalData,
			autoSchedulingDragPersonId,
			autoSchedulingDragTranslateX,
			autoSchedulingDragTranslateY,
			isShowingAutoScheduleLoader,
			project,
			assignedPersonHoverData,
			shouldShowScrollFade,
			dataLoaded,
			lightweightDataLoaded,
			clickedItem,
			loadingAutoSchedule,
			showLoader,
			recalculateSteps,
			splitAllocationBarData,
			preventFiltering,
		} = this.state;
		const availableData = data || lightWeightData;
		if (isClientUser()) return null; //Do not render anything if client tried accessing the page
		let holidaysEntriesCanvasFormat = [];

		// in the new desgin the holidays maked with the diagonal lines pattern from the top of the canvas to the bottom is the default calendar. if there is no default calendar only weekends will have the pattern
		const defaultHolidayCalendarEntries = availableData
			? availableData.holidayCalendarEntries.filter(
					entry => entry.holidayCalendarId === availableData.company.defaultHolidayCalendarId
			  )
			: [];
		holidaysEntriesCanvasFormat = availableData
			? defaultHolidayCalendarEntries.map(entry => createCanvasTimelineDate(entry.year, entry.month, entry.day))
			: [];

		let startDate = 0,
			endDate = 0;
		if (autoScheduleProposalData && this.state.simulationMode) {
			if (autoScheduleProposalData.earliestStartDate) {
				startDate = autoScheduleProposalData.earliestStartDate;
			}
			if (autoScheduleProposalData.latestEndDate) {
				endDate = autoScheduleProposalData.latestEndDate;
			}
		}

		const filteredFooterPersons = getFilteredFooterPersons(this);
		if (lightweightDataLoaded || dataLoaded) {
			if (!preventFiltering) {
				filterProjectGroupsV4(this, groups);
				filterTasksV4(this, groups);
			}
		}

		if (isProjectTimeline) {
			const timelineForProjectFromProjectGroup =
				projectId !== undefined &&
				availableData.projects.some(
					project => project.companyProjectId === parseInt(projectId) && project.isInProjectGroup
				);
			// In Project Timeline we need to filter out groups from other projects.
			groups
				.filter(group => !group.filtered)
				.forEach(group => {
					if (projectId !== undefined) {
						if (timelineForProjectFromProjectGroup && group.data.isConnectedProject) {
							group.filtered =
								!group.groups || !group.groups.some(gr => gr.data.companyProjectId === parseInt(projectId));
							group.groups
								.filter(nestedGroup => !nestedGroup.filtered)
								.forEach(nestedGroup => {
									nestedGroup.filtered =
										nestedGroup.groupType === GROUP_TYPE.PROJECT_SCHEDULING_PROJECT &&
										nestedGroup.data.companyProjectId !== parseInt(projectId);
								});
						} else {
							group.filtered = group.data.companyProjectId !== parseInt(projectId);
						}
					} else if (groupId !== undefined) {
						const projectGroupId = availableData.projectGroups.find(
							projectGroup => projectGroup.companyProjectGroupId === parseInt(this.props.groupId)
						).id;
						const projectIds = availableData.projects
							.filter(project => project.projectGroupId === projectGroupId)
							.map(project => project.companyProjectId);
						group.filtered =
							group.data.companyProjectGroupId !== parseInt(this.props.groupId) &&
							!projectIds.includes(group.data.companyProjectId);
					} else if (shareUrl !== undefined) {
						group.filtered = group.data.companyProjectId !== availableData.sharedProjectCompanyProjectId;
					}
				});
		}

		const isApplyAutoScheduleDisabled =
			!this.state.autoScheduleProposalData ||
			!this.state.autoScheduleProposalData.taskData ||
			this.state.autoScheduleProposalData.taskData.length === 0;
		const topLeftComponent =
			isProjectTimeline || sharedContext ? (
				<div className="project-scheduling-top-left" />
			) : (
				<div className="project-scheduling-top-left">
					<Button
						className={'new-project-button-v2'}
						text={formatMessage({id: 'new_project.title'})}
						buttonStyle={BUTTON_STYLE.OUTLINE}
						colorTheme={BUTTON_COLOR.PURPLE}
						onClick={() => {
							this.setState({
								clickedItem: null,
								movedItem: null,
								showLoader: false,
							});
							tracking.trackElementClicked('Add new project');
							showModal({type: MODAL_TYPE.NEW_PROJECT_V2});
						}}
						userpilot={'schedule-new-project'}
					/>
				</div>
			);
		const isCollapsableSectionExpanded = false;
		const actionMenuOptions = [];
		if (expandedActionMenuData) {
			actionMenuOptions.push({
				text: formatMessage({
					id:
						expandedActionMenuData.companyProjectId !== undefined
							? 'scheduling.allocation_modal.view_project'
							: 'overview_projects.group_link',
				}),
				onClick: () => {
					this.viewProject(
						expandedActionMenuData.companyProjectGroupId !== undefined,
						expandedActionMenuData.companyProjectGroupId !== undefined
							? expandedActionMenuData.companyProjectGroupId
							: expandedActionMenuData.companyProjectId
					);
				},
			});
			if (expandedActionMenuData.companyProjectId !== undefined) {
				if (
					expandedActionMenuData.status === PROJECT_STATUS.PLANNING ||
					expandedActionMenuData.status === PROJECT_STATUS.OPPORTUNITY
				) {
					actionMenuOptions.push({
						text: formatMessage({id: 'running_reminder_modal.button_text'}),
						onClick: this.setProjectStatus.bind(this, expandedActionMenuData.id, PROJECT_STATUS.RUNNING),
					});
				}

				actionMenuOptions.push({
					text: formatMessage({id: 'project_settings.duplicate-project'}),
					onClick: this.duplicateProject.bind(this, expandedActionMenuData.id),
				});
				if (!expandedActionMenuData.hasInvoice) {
					actionMenuOptions.push({
						text: formatMessage({id: 'settings.delete-project'}),
						onClick: this.deleteProject.bind(this, expandedActionMenuData.id),
					});
				}
			}
		}

		if (dataLoaded) {
			if (clickedItem) {
				this.onDistributionItemClick(clickedItem.itemType, clickedItem.parentId, clickedItem.childId, clickedItem.item);
			}
			if (loadingAutoSchedule) {
				this.showAutoSchedulingModal();
			}
		}

		let width, height, top, left;
		if (this.timeline && this.timeline) {
			width = window.innerWidth;
			height = window.innerHeight - this.timeline.state.canvasOffsetTop;
			top = this.timeline.state.canvasOffsetTop;
			left = 0;
		}

		// find id of project/project group viewed in project timeline, needed for save filter action
		let actualProjectId = null;
		let actualProjectGroupId = null;
		if (projectId) {
			if (project) {
				actualProjectId = project.id;
			} else if (availableData && availableData.projects) {
				const matchingProject = availableData.projects.find(el => el.companyProjectId === projectId);
				actualProjectId = matchingProject ? matchingProject.id : null;
			}
		} else if (groupId && availableData && availableData.projectGroups) {
			const matchingProjectGroup = availableData.projectGroups.find(el => el.companyProjectGroupId === parseInt(groupId));
			actualProjectGroupId = matchingProjectGroup ? matchingProjectGroup.id : null;
		}

		return (
			<>
				{this.state.showLoadingOverlay ? <UploadingOverlay /> : null}
				{isShowingAutoScheduleLoader ? <AiLoader absolute /> : null}
				{this.state.initData.featureFlags.some(flag => flag.key === 'third_level_nav') && !sharedContext && (
					<div style={{backgroundColor: '#fff'}}>
						<TopHeaderBarWrapper sidePadding={24} bottomPadding={0}>
							<TopHeaderBar
								title={this.props.intl.formatMessage({
									id: isProjectTimeline ? 'project_timeline.title' : 'scheduling.menu.schedule_projects',
								})}
								content={getTopHeaderContent(this, isProjectTimeline)}
							/>
						</TopHeaderBarWrapper>
					</div>
				)}
				<div className="control-bar">
					{createHeader(this, isProjectTimeline, projectId, groupId, actualProjectId, actualProjectGroupId)}
				</div>
				<div
					id="project-timeline"
					className={'canvas-projects-scheduling' + (this.state.simulationMode ? ' simulation-mode' : '')}
				>
					{this.state.simulationMode && assignedPersonHoverData ? (
						<div
							className="person-info-box"
							style={{
								height: assignedPersonHoverData.data.height,
								top: assignedPersonHoverData.data.y + 'px',
								left:
									assignedPersonHoverData.data.x +
									assignedPersonHoverData.data.width +
									AUTO_SCHEDULING_PERSON_WIDTH +
									(assignedPersonHoverData.data.item.data.task.isOverAllocated
										? AUTO_SCHEDULING_PERSON_WIDTH
										: AUTO_SCHEDULING_PERSON_WIDTH / 2) +
									'px',
							}}
						>
							<div className="name">
								{assignedPersonHoverData.overAllocated
									? formatMessage({id: 'scheduling.over_allocated'})
									: assignedPersonHoverData.data.item.data.task.autoSchedulingPerson.firstName +
									  ' ' +
									  assignedPersonHoverData.data.item.data.task.autoSchedulingPerson.lastName}
							</div>
						</div>
					) : null}
					{this.state.simulationMode ? (
						<>
							{this.state.footerPersonHoverData && this.state.footerPersonHoverData.person ? (
								<div
									ref={div => (this.footerHoverDiv = div)}
									className="footer-person-tooltip-container"
									style={{
										opacity: this.state.footerPersonHoverData.opacity,
										top: this.state.footerPersonHoverData.top + 'px',
										left: this.state.footerPersonHoverData.left + 'px',
									}}
								>
									{this.state.footerPersonHoverData.person.firstName +
										' ' +
										this.state.footerPersonHoverData.person.lastName}
								</div>
							) : null}
							<div className="bar left" style={{backgroundColor: project.projectColor}} />
							<div className="bar right" style={{backgroundColor: project.projectColor}} />

							<div
								className="simulation-header"
								style={{backgroundColor: project.projectColor}}
								data-cy="simulation-mode-header"
							>
								<div className="title">{formatMessage({id: 'auto_scheduling.auto_schedule'})}</div>
								<div className="project-details">
									<div className="project-id">P{project.companyProjectId}</div>
									<div className="project-name">{project.name}</div>
								</div>
								<div
									className="close-simulation close-button"
									onClick={() => disableSimulationMode(this, true)}
								/>
							</div>
						</>
					) : null}
					<div className="hover-effects-container">
						{showCollapsedActionMenu &&
						(!showExpandedActionMenu || collapsedActionMenuY !== expandedActionMenuY) ? (
							<div className="project-scheduling-actions-menu" style={{top: collapsedActionMenuY}}>
								<ActionMenu
									options={actionMenuOptions}
									onExpansionToggle={this.showExpandedActionMenu.bind(this)}
									expanded={false}
									useGreyIcon={true}
								/>
							</div>
						) : null}
						{showExpandedActionMenu ? (
							<div className="project-scheduling-actions-menu" style={{top: expandedActionMenuY}}>
								<ActionMenu
									options={actionMenuOptions}
									onExpansionToggle={this.hideExpandedActionMenu.bind(this)}
									expanded={true}
									useGreyIcon={true}
								/>
							</div>
						) : null}
						{showArrowClickableArea ? (
							<div
								className="project-scheduling-arrow-clickable-area previous"
								onClick={this.onPhasesGroupArrowClick.bind(this, true)}
								style={{top: arrowClickableAreaY}}
							/>
						) : null}
						{showArrowClickableArea ? (
							<div
								className="project-scheduling-arrow-clickable-area next"
								onClick={this.onPhasesGroupArrowClick.bind(this, false)}
								style={{top: arrowClickableAreaY}}
							/>
						) : null}
						{showDistributionBox ? (
							<DistributionBox
								positionX={distributionBoxX}
								positionY={distributionBoxY}
								distributionBoxData={distributionBoxData}
								data={data}
								getPhaseCompletion={this.getPhaseCompletion.bind(this)}
							/>
						) : null}
						{contextMenuX && contextMenuY && contextMenuOptions && contextMenuOptions.length ? (
							// we are setting the key to be the sum of the coordinates because this will cause a rerender of the context menu if the user right clicks on another item
							// solves the issue of the context menu not updating the position
							<ContextMenu
								key={contextMenuX + contextMenuY}
								cy="canvas-project-scheduling-context-menu"
								options={contextMenuOptions}
								contextMenuPosition={{x: contextMenuX, y: contextMenuY}}
							/>
						) : null}
						{showDetailBox ? (
							<div
								className="project-scheduling-detail-box"
								style={{
									left: detailBoxX + 200 < window.innerWidth ? detailBoxX + 10 : detailBoxX - 235,
									top: detailBoxY + 350 < window.innerHeight ? detailBoxY - 5 : 'unset',
									bottom:
										detailBoxY + 350 < window.innerHeight ? 'unset' : window.innerHeight - detailBoxY - 40,
								}}
							>
								{detailBoxData.task ? (
									<TaskDetailBox
										task={detailBoxData.task}
										globalData={data}
										positionX={detailBoxX}
										positionY={detailBoxY}
									/>
								) : (
									<AllocationDetailBox
										taskAllocationTotalEstimate={detailBoxData.totalEstimates}
										allocation={detailBoxData.allocation}
										globalData={data}
										positionX={detailBoxX}
										positionY={detailBoxY}
									/>
								)}
							</div>
						) : null}
					</div>
					<CanvasTimeline
						ref={timeline => (this.timeline = timeline)}
						key={this.state.simulationMode}
						groups={groups}
						items={items}
						topLeftComponent={topLeftComponent}
						isCollapsableSectionExpanded={isCollapsableSectionExpanded}
						collapsableSectionGroups={[]}
						dayData={dayData}
						holidaysEntries={holidaysEntriesCanvasFormat}
						isSingleGroup={true}
						onDrawForegroundEnd={this.onDrawForegroundEnd.bind(this)}
						onDrawForegroundStart={this.onDrawForegroundStart.bind(this)}
						getDependencyData={dataLoaded ? dragData => getDependencyData(this, dragData) : null}
						getVisibleTasksInHierarchy={this.getVisibleTasksInHierarchy.bind(this)}
						onDependencyCreation={
							dataLoaded
								? (thisDependsOnTaskId, taskIdDependsOnThis, isFinishToStartDependency) =>
										onDependencyCreation(
											this,
											thisDependsOnTaskId,
											taskIdDependsOnThis,
											isFinishToStartDependency
										)
								: null
						}
						onForegroundContextMenu={this.onForegroundContextMenu.bind(this)}
						startDate={startDate}
						endDate={endDate}
						getDependencyChainTaskIdSet={taskId => getDependencyChainTaskIdSet(this, taskId)}
						onMouseUpEnd={this.onMouseUpEnd.bind(this)}
						onMouseMoveEnd={this.onMouseMoveEnd.bind(this)}
						simulationMode={this.state.simulationMode}
						onGroupExpansionToggle={this.onGroupExpansionToggle.bind(this)}
						onVerticalScroll={this.onTimelineVerticalScroll.bind(this)}
						onHorizontalScroll={this.onTimelineHorizontalScroll.bind(this)}
						debugData={data}
						dataLoaded={dataLoaded}
						eyeOptions={this.state.projectSchedulingDetailSelectorOptions}
						isProjectTimeline={this.props.isProjectTimeline}
						recalculateSteps={recalculateSteps}
						resetRecalculateSteps={this.resetRecalculateSteps.bind(this)}
						splitAllocationBarData={splitAllocationBarData.visible ? splitAllocationBarData : null}
						isProjectScheduling={!this.props.isProjectTimeline}
						setPreventFiltering={this.setPreventFiltering.bind(this)}
						isUsing35Frames={this.isUsing35Frames}
						isUsing67Frames={this.isUsing67Frames}
						isUsingInstantZoom={this.isUsingInstantZoom}
						initialZoomLevel={this.state.initData.projectSchedulingShare?.zoomLevel}
					/>
					{dataLoaded ? (
						this.state.simulationMode ? (
							<div className="simulation-footer" style={{borderColor: project.projectColor}}>
								<div className="assign-persons-container">
									<AutoSchedulingDropdown
										useSmallerStyling={true}
										assignablePersons={this.getData().persons.filter(
											person => person.active && !person.clientId
										)}
										assignedPersons={this.state.footerPersons}
										assignableRoles={this.getData().roles}
										assignPerson={person => addFooterPerson(this, person)}
										unassignPerson={person => removeFooterPerson(this, person)}
										autoFocus={false}
										disabled={false}
										isMultiSelect={true}
										viewer={data.viewer}
										updateDropdownSearchCriteria={searchCriteria =>
											updateDropdownSearchCriteria(this, searchCriteria)
										}
										onPersonsChange={this.setScrollFade.bind(this)}
									/>
								</div>
								{shouldShowScrollFade ? (
									<div className="faded-overlay left">
										<div className="fade" />
									</div>
								) : null}

								<div style={{display: 'flex', flexGrow: 1, height: '55px'}}>
									<CustomScrollDiv ref={div => (this.scrollbar = div)} horizontalContent={true}>
										<div ref={div => (this.projectPersonsDiv = div)} className="project-persons">
											{filteredFooterPersons.length !== 0
												? filteredFooterPersons.map(person => (
														<React.Fragment key={person.id}>
															{autoSchedulingDragPersonId &&
															autoSchedulingDragPersonId === person.id ? (
																<div style={{width: '34px'}} />
															) : null}
															<div
																// title={person.firstName + ' ' + person.lastName}
																className="project-person drag"
																id={person.id}
																draggable="true"
																onMouseDown={e => onPersonMouseDown(this, person.id, e)}
																onMouseEnter={e =>
																	handleFooterPersonMouseEnter(this, person, e)
																}
																onMouseLeave={() => handleFooterPersonMouseLeave(this)}
																style={
																	autoSchedulingDragPersonId === person.id
																		? {
																				position: 'fixed',
																				top: 0,
																				left: 0,
																				transform: `translate(${autoSchedulingDragTranslateX}px, ${autoSchedulingDragTranslateY}px)`,
																		  }
																		: undefined
																}
															>
																<Person
																	name={`${person.firstName} ${person.lastName}`}
																	showName={false}
																	showRole={false}
																	imageSrc={
																		person.profilePictureId
																			? profilePicSrc(person.profilePictureId)
																			: null
																	}
																	imageSize="large"
																/>
															</div>
														</React.Fragment>
												  ))
												: null}
										</div>
									</CustomScrollDiv>
								</div>

								{this.state.footerWarnings.length > 0 ? (
									<div className="footer-warnings">
										{this.state.footerWarnings.map(w => (
											<p>{w}</p>
										))}
									</div>
								) : (
									''
								)}

								<div className="actions">
									<Button
										text={formatMessage({id: 'common.cancel'})}
										onClick={() => disableSimulationMode(this, true)}
										buttonStyle={BUTTON_STYLE.FILLED}
										colorTheme={BUTTON_COLOR.WHITE}
									/>
									<Button
										text={formatMessage({id: 'auto_scheduling.reschedule'})}
										onClick={this.onRescheduleButtonPress.bind(this)}
										buttonStyle={BUTTON_STYLE.OUTLINE}
										colorTheme={BUTTON_COLOR.AI_BLUE}
									/>
									<Button
										isDisabled={isApplyAutoScheduleDisabled}
										text={formatMessage({id: 'settings_subscription.apply'})}
										onClick={() => onApplySimulationChanges(this)}
										buttonStyle={BUTTON_STYLE.FILLED}
										autoScheduleStyle
										buttonTitle={
											isApplyAutoScheduleDisabled
												? formatMessage({id: 'auto_scheduling.apply_button_disabled_info'})
												: undefined
										}
									/>
								</div>
							</div>
						) : null
					) : null}
					{this.state.savingMutation ? (
						<div className="is-saving">
							<div className="backdrop" style={{width, height, top, left}} />
							<div className="description">Saving. Please wait until it is finished.</div>
						</div>
					) : null}
					{showLoader ? <div className="is-loading" /> : null}
				</div>

				{/* userpilot targets */}
				<div className="userpilot-target first-project" data-userpilot={'first-project'} />
				<div className="userpilot-target first-project-progress" data-userpilot={'first-project-progress'} />
				<div className="userpilot-target first-project-expand-icon" data-userpilot={'first-project-expand-icon'} />
				<div className="userpilot-target first-project-milestones" data-userpilot={'first-project-milestones'} />
				<div
					className="userpilot-target first-project-milestones-expand"
					data-userpilot={'first-project-milestones-expand'}
				/>
				<div
					className="userpilot-target first-project-first-milestone"
					data-userpilot={'first-project-first-milestone'}
				/>
				<div
					className="userpilot-target first-project-first-milestone"
					data-userpilot={'first-project-first-milestone'}
				/>
				<div
					className="userpilot-target first-project-first-milestone-expand"
					data-userpilot={'first-project-first-milestone-expand'}
				/>
				<div className="userpilot-target first-task" data-userpilot={'first-task'} />
				<div className="userpilot-target first-project-team" data-userpilot={'first-project-team'} />
				<div className="userpilot-target first-project-team-expand" data-userpilot={'first-project-team-expand'} />
				<div className="userpilot-target project-team-heatmap" data-userpilot={'project-team-heatmap'} />
				<div className="userpilot-target all-projects-timeline" data-userpilot={'all-projects-timeline'} />
				<div
					className="userpilot-target project-scheduling-task"
					id="user-pilot-project-scheduling-task"
					data-userpilot={'project-scheduling-task'}
				/>
			</>
		);
	}
}

CanvasProjectsScheduling.propTypes = {
	setTimeline: PropTypes.func.isRequired,
	sharedContext: PropTypes.bool,
};
export default injectIntl(CanvasProjectsScheduling, {forwardRef: true});
